import { useEffect, useState } from 'react';
import { ApercuCharges } from '../../components/ApercuCharges.jsx';
import { BoutonDocument } from '../../components/BoutonDocument.jsx';
import { ClasseurLettres } from './ClasseurLettres.jsx';
import { Shell } from '../../components/layout/Shell.jsx';
import { Bar } from '../../components/ui/Bar.jsx';
import { Btn } from '../../components/ui/Btn.jsx';
import { Card } from '../../components/ui/Card.jsx';
import { FR } from '../../components/ui/FieldRow.jsx';
import { Inp } from '../../components/ui/Inputs.jsx';
import { StatBox } from '../../components/ui/StatBox.jsx';
import { Tabs } from '../../components/ui/Tabs.jsx';
import { dtoVersFacture, factureVersDto, isoVersDate } from '../../api/mappers';
import { useReglages } from '../../api/reglages.jsx';
import { FRAIS_CAT } from '../../constants/accounting';
import { PanneauDuType } from './ClasseurDuType.jsx';
import { ClotureA4 } from '../documents/ClotureA4.jsx';
import { RapportComptaA4 } from '../documents/RapportComptaA4.jsx';
import { PositionTva } from './PositionTva.jsx';
import { devisApi, facturesApi, piecesApi, tvaApi, vehiculesApi } from '../../api/resources';
import { vehiculesDeLAnnee } from '../../lib/vehicules';
import { VehiculesCompta } from './VehiculesCompta.jsx';
import { ouvreDonnees, ouvrePiece } from '../../components/DocumentsJoints.jsx';
import { depensesDuClasseur, TYPES_DU_CLASSEUR } from '../../lib/classeur-depenses';
import { stockAuDebut, variationDuStock } from '../../lib/valeur-stock';
import {
  debiteursAu31Decembre,
  noteLeSolde,
  soldesDeLAnnee,
  stockAu31Decembre,
} from '../../lib/bilan-exercice';
import { dejaPayeEtat, sansPaiementsEtat } from '../../lib/paiements-etat';
import { recuDansLaPeriode } from '../../lib/paiements-ecrits';
import { idProvisoire } from '../../lib/identifiants';
import { chargesReparties, regroupeLesParts } from '../../lib/depenses-reparties';
import { AcomptesAnnee } from './AcomptesAnnee.jsx';
import { AcomptesAnterieurs } from './AcomptesAnterieurs.jsx';
import { ClasseurClients } from './ClasseurClients.jsx';
import { usePaiements } from '../../components/PaiementsRecus.jsx';
import {
  acomptesRecusDAvance,
  CLE_REGLE_ACOMPTES,
  avecRegleDeLAnnee,
  piecesComptables,
  reglesAcomptes,
} from '../../lib/acomptes-anterieurs';
import { bornesTva } from '../../lib/periodes-tva';
import { lisCamt053 } from '../../lib/camt';
import { lisRelevePdf } from '../../lib/releve-pdf';
import { banqueDuCamt, gardeLeReleve } from '../../lib/banque-releve';
import { RelevesBanque } from './RelevesBanque.jsx';
import { PaiementsFactures } from './PaiementsFactures.jsx';
import { ClasseurChantiers } from './ClasseurChantiers.jsx';
import { AttestationsEntreprise } from './AttestationsEntreprise.jsx';
import { DossierAnnee } from './DossierAnnee.jsx';
import { CaseTauxVerifiee } from '../../components/CaseTauxVerifiee.jsx';
import { textePaye } from '../../lib/paye-le';
import {
  demandePaiementsA4,
  groupesDePaiements,
  sansTexteDuBulletin,
  sourceDuPaiement,
} from '../../lib/paiements-a4';
import { PayeLe } from '../../components/PayeLe.jsx';
import { factureDeLaDepense } from '../../lib/depenses-mensuelles';
import { CasiersPersonnel } from './CasiersPersonnel.jsx';
import { FacturesClientsClasseur } from './FacturesClientsClasseur.jsx';
import { MouvementsReleve } from './MouvementsReleve.jsx';
import { paiementsDuReleve, rapprocheSorties } from '../../lib/rapprochement-sorties';
import {
  cleMouvement,
  fusionneReleves,
  noteMouvement,
  retireMouvement,
  sensConnu,
  totauxDuReleve,
} from '../../lib/releve-bancaire';
import { encaissementsDuReleve, factureApresPaiement } from '../../lib/rapprochement-entrees';
import { peutEncaisser, voitLesAttestations } from '../../lib/access';
import { nomComplet } from '../../lib/acces';
import {
  CLE_BILAN,
  CLE_CLOTURES,
  CLE_COMPTABLE,
  anneeDe,
  anneesDisponibles,
  composeCloture,
  periodesComptable,
  premiereAnneeDuComptable,
  soldeComptable,
} from '../../lib/cloture';
import { estAvoir } from '../../lib/caisse';
import {
  impotsAProvisionner,
  TAUX_COMPTA_INHABITUELS,
  tauxCompta,
  tauxComptaModifies,
  tauxComptaParDefaut,
  tauxComptaRemis,
  tauxPatronauxTotal,
} from '../../lib/charges';
import { achatsDuChantier, useAchatsJoints } from '../../components/ListeDuClient.jsx';
import { depensesHt } from '../../lib/depenses-ht';
import { chantierCosts, tvaFactureFournisseur } from '../../lib/costs';
import { moisDeLaPeriode, salairesDeLaPeriode } from '../../lib/salaires-periode';
import { useMaFiche } from '../../api/maFiche';
import { estIndependant } from '../equipe/EmpEditor.jsx';
import { DEVISE, fmt } from '../../lib/currency';
import { modulesSouscrits, universMagasin } from '../../lib/modules';
import {
  auCentime,
  compteDansLeCa,
  decompteTva,
  htDocument,
  PREFIXE_DEDUCTION,
  htVente,
  signeCa,
  totauxDocument,
  ttcDocument,
  tvaDeLaDepense,
  tvaRecuperable,
} from '../../lib/vat';
import { tauxTvaEnVigueur } from '../../lib/tva';
import { today } from '../../lib/utils';
import { C } from '../../theme/palette';
import { tr, trf } from '../../lib/i18n';
import { regleeParAvoir, soldeApresAvoirs, totalAEncaisser } from '../../lib/impayes';

export function ComptaPage({
  onNav,
  soc,
  setSoc,
  factures: facturesToutes,
  setFactures,
  chantiers,
  setChantiers,
  employes,
  conges,
  ventes,
  stock,
  clients,
  devis,
  commandes,
  livraisons,
  frais: fraisTous,
  setFrais,
  estMixte,
  univers,
  setUnivers,
  ouvrir,
  attestations,
  rechargeFactures,
  rechargeDevis,
  rechargeChantiers,
}) {
  const { reglageJson, setReglageJson } = useReglages();
  const maFiche = useMaFiche();
  // Univers affiché : les marges et le classeur des chantiers sont du
  // bâtiment, les commandes et les bons de livraison du magasin.
  const magC = universMagasin({ soc, estMixte, univers });
  // Le comptable, les clotures et les soldes du bilan vivent dans les
  // parametres de la societe : la fiche societe ne porte pas de colonne pour
  // eux, et ce qui y etait saisi se perdait au rechargement.
  const comptable = reglageJson(CLE_COMPTABLE, null);
  const clotures = reglageJson(CLE_CLOTURES, {});
  const bilan = reglageJson(CLE_BILAN, {});

  const anneeCourante = new Date().getFullYear();
  const [anneeC, setAnneeC] = useState(anneeCourante);
  // Un acompte versé l'année d'avant sa facture (« Paiements reçus ») compte
  // dans l'année choisie par la société : une part « acompte » datée du
  // versement, ou tout dans l'année de la facture.
  const { paiements } = usePaiements((facturesToutes || []).length);
  const reglageAc = reglageJson(CLE_REGLE_ACOMPTES, null);
  // La règle de chaque année de versement : le patron choisit année par année.
  const regleAc = reglesAcomptes(reglageAc);
  const piecesC = piecesComptables(facturesToutes, paiements, regleAc);
  const anneesDispo = anneesDisponibles(piecesC, fraisTous);
  // La comptabilite se lit par exercice : tout ce qui suit ne voit que
  // l'annee choisie, faute de quoi le compte de resultat melerait les annees.
  const factures = piecesC.filter((f) => anneeDe(f) === anneeC);
  // Les paiements à l'État (TVA, AVS, impôts) restent dans le classeur, mais
  // ne sont pas des dépenses : la TVA reversée a été encaissée, l'AVS et les
  // impôts sont estimés sur le bénéfice.
  const fraisDeLAnnee = (fraisTous || []).filter((x) => anneeDe(x) === anneeC);
  const frais = sansPaiementsEtat(fraisDeLAnnee);
  // Les mêmes dépenses comme charges : celle répartie sur les mois qu'elle
  // couvre (l'assurance de l'année payée en janvier) compte pour ses mois de
  // l'exercice, une part par mois. La TVA et la banque gardent le paiement.
  const chargesDeLAnnee = chargesReparties(sansPaiementsEtat(fraisTous), soc).filter(
    (x) => anneeDe(x) === anneeC,
  );
  const ventesExercice = (ventes || []).filter((v) => anneeDe(v) === anneeC);
  // Les taux en vigueur sur l'exercice, tels que Reglages → Documents les
  // regle : le taux normal est celui que la caisse ajoutait aux prix du
  // catalogue — la TVA declaree doit etre celle qui a ete encaissee.
  const tauxExercice = tauxTvaEnVigueur(soc, anneeC + '-12-31');
  const tauxMagasin = tauxExercice.normal;
  const [clotureA4, setClotureA4] = useState(null);

  // « Ouvrir le classeur » (Archives) arrive sur l'onglet Documents, pas sur
  // la Synthèse.
  const [tab, setTab] = useState(ouvrir?.onglet || 'synthese');
  useEffect(() => {
    if (ouvrir?.onglet) setTab(ouvrir.onglet);
  }, [ouvrir]);
  const [jAnnee, setJAnnee] = useState('');
  const [fAdd, setFAdd] = useState(false);
  const [fNew, setFNew] = useState({
    type: 'vehicule',
    libelle: '',
    montant: '',
    piece: '',
    pieceNom: '',
    pieceMime: '',
  });
  const [cptForm, setCptForm] = useState(
    comptable || { nom: '', adresse: '', tel: '', email: '', montant: '', freq: 'mensuel' },
  );
  const [periodeC, setPeriodeC] = useState('annee');
  // Position TVA du serveur pour la période de la vue complète.
  const [positionPeriode, setPositionPeriode] = useState(null);
  useEffect(() => {
    let actif = true;
    const [debutP, finP] = bornesTva(anneeC, periodeC);
    Promise.resolve()
      .then(() => tvaApi.position(debutP, finP))
      .then((position) => {
        if (actif) setPositionPeriode({ cle: anneeC + '-' + periodeC, position });
      })
      .catch(() => {});
    return () => {
      actif = false;
    };
  }, [anneeC, periodeC, facturesToutes, fraisTous, ventes]);
  const [rapA4, setRapA4] = useState(null);
  // La comptabilite recalculait ses propres totaux : elle oubliait la remise
  // globale et appliquait le taux du document a l'ensemble du hors-taxe. Le
  // chiffre d'affaires, les impayes, l'echeancier et la TVA due s'en trouvaient
  // fausses — et c'est la TVA que l'on declare a l'AFC.
  const ttcOf = ttcDocument;
  const htOf = htDocument;
  // L'argent reçu : la part payée de chaque facture — une facture payée en
  // partie comptait pour rien — et les ventes au comptoir, payées sur place.
  const partPayee = (f) =>
    f.statut === 'Payée'
      ? 1
      : f.statut === 'Partielle' && ttcOf(f) > 0
        ? Math.min(1, (+f.paidAmount || 0) / ttcOf(f))
        : 0;
  // Rangé à la date de l'encaissement, comme la trésorerie de l'accueil :
  // une facture de décembre payée en janvier est encaissée en janvier. Elle
  // se rangeait à l'année de la facture.
  const encaisseDansLExercice = (f) => {
    const ttc = ttcOf(f);
    if (!(ttc > 0)) return 0;
    // Chaque paiement à sa date, l'acompte écrit en bas de la facture
    // compris : l'acompte de 2025 se recomptait dans l'encaissé de 2026.
    return recuDansLaPeriode(
      f,
      paiements?.get(f.id),
      ttc * partPayee(f),
      (d) => anneeDe({ date: d }) === anneeC,
    );
  };
  const caEncaisse =
    (facturesToutes || [])
      .filter((f) => f.type !== 'avoir' && compteDansLeCa(f))
      .reduce((s, f) => s + (encaisseDansLExercice(f) * htOf(f)) / ttcOf(f), 0) +
    ventesExercice.reduce((s, v) => s + htVente(v), 0);
  // Ce qui compte dans le chiffre d'affaires : les factures parties, avoirs
  // deduits — ni les brouillons ni les annulees, que la synthese additionnait.
  const totalFacture = factures
    .filter(compteDansLeCa)
    .reduce((s, f) => s + signeCa(f) * htOf(f), 0);
  // Le même total, TVA comprise : ce qui a réellement été facturé au client.
  const totalFactureTtc = factures
    .filter(compteDansLeCa)
    .reduce((s, f) => s + signeCa(f) * ttcOf(f), 0);
  // L'AFC admet deux methodes, et le decompte etait fige sur la seconde :
  // celle d'une entreprise qui ne declare qu'a l'encaissement. La plupart
  // decomptent a la facturation — c'est le regime qu'on recoit en s'annoncant
  // — et leur decompte restait a zero tant qu'un client n'avait pas paye.
  const methodeTva = soc?.tvaMethode === 'recues' ? 'recues' : 'convenues';
  // Le décompte hors ligne suit la règle du serveur : il lit toutes les
  // factures et leurs paiements, et retient ce qui tombe dans l'exercice — un
  // acompte facturé à sa date, même rangé dans l'année des travaux ; à
  // l'encaissement, chaque paiement à sa date.
  const dansLExercice = (d) => anneeDe({ date: d }) === anneeC;
  const decompte = decompteTva({
    factures: facturesToutes,
    paiements,
    dansLaPeriode: dansLExercice,
    ventes: ventesExercice,
    tauxVentes: tauxMagasin,
    frais,
    categories: FRAIS_CAT,
    soc,
    methode: methodeTva,
  });
  // Chaque famille de frais porte son taux : le taux normal sur le materiel,
  // le taux reduit sur les denrees, rien sur ce qui n'ouvre pas droit a
  // deduction. Le taux normal applique a tout reclamait a l'AFC une deduction
  // que l'entreprise n'a pas.
  const tvaDeductible = decompte.deductible;
  const tvaCollectee = decompte.collectee;
  const tvaNette = decompte.nette;
  // Le solde restant, et non le total : une facture payee a moitie ne doit pas
  // figurer pour son montant entier.
  const impayes = totalAEncaisser(factures, devis);
  // Un employe parti ne greve plus la masse salariale : l'y laisser gonflait
  // les charges de toutes les entreprises ayant connu un depart.
  // La synthèse compte comme la vue complète : les salaires réellement dus
  // (heures × taux, sinon salaire mensuel) avec les charges patronales, et
  // les achats hors TVA récupérable, factures des chantiers comprises. Elle
  // additionnait les salaires de base (zéro pour un employé à l'heure), les
  // frais TVA comprise et la valeur du stock : son bénéfice ne correspondait
  // pas à celui de la vue complète.
  const salairesAnnee = salairesDeLaPeriode({
    employes,
    chantiers,
    mois: moisDeLaPeriode(anneeC, 'annee'),
    soc,
    exclu: (e) => e?.patronIndependant || (estIndependant(soc?.forme) && maFiche.estLaMienne(e)),
  });
  const masseSal =
    salairesAnnee +
    (salairesAnnee *
      tauxPatronauxTotal(
        tauxCompta(soc, anneeC),
        modulesSouscrits(estMixte ? 'mixte' : soc?.secteur).batiment,
      )) /
      100;
  // La marchandise et la sous-traitance jointes aux offres et factures, même
  // payées, sont des achats de l'exercice.
  const achatsJoints = useAchatsJoints((facturesToutes || []).length);
  /**
   * Note le jour de paiement trouvé dans le relevé : sur la dépense, la
   * facture fournisseur ou le sous-traitant du chantier, ou la pièce jointe.
   *
   * @param {object[]} aDater liens de {@link paiementsDuReleve}, avec leur jour
   */
  const dateLesPaiements = (aDater) => {
    const de = (genre) => aDater.filter((l) => l.genre === genre);
    if (de('depense').length && typeof setFrais === 'function') {
      // La dépense liée se reconnaît à son numéro, son montant et sa date :
      // un numéro repris par une autre dépense datait payée la mauvaise. Une
      // dépense déjà datée garde sa date.
      const memeDepense = (l, x) =>
        l.id != null &&
        l.id === x.id &&
        (l.montant === undefined || Math.abs((+x.montant || 0) - (+l.montant || 0)) < 0.005) &&
        (!l.date || String(x.date || '') === String(l.date));
      setFrais((p) =>
        p.map((x) => {
          if (x.payeLe) return x;
          const l = de('depense').find((y) => memeDepense(y, x));
          return l ? { ...x, payeLe: l.jour, paiement: x.paiement || 'banque' } : x;
        }),
      );
    }
    const surChantier = [...de('fournisseur'), ...de('soustraitant')];
    if (surChantier.length && typeof setChantiers === 'function') {
      const date = (liste, genre, chId) =>
        (liste || []).map((x) => {
          const l = surChantier.find(
            (y) => y.genre === genre && y.id === x.id && String(y.chantierId) === String(chId),
          );
          return l ? { ...x, payeLe: l.jour, payePar: 'banque' } : x;
        });
      setChantiers((p) =>
        p.map((c) =>
          surChantier.some((l) => String(l.chantierId) === String(c.id))
            ? {
                ...c,
                factures: date(c.factures, 'fournisseur', c.id),
                sousTraitants: date(c.sousTraitants, 'soustraitant', c.id),
              }
            : c,
        ),
      );
    }
    de('piece').forEach((l) => {
      Promise.resolve()
        .then(() => piecesApi.paiement(l.id, l.jour, 'banque'))
        .catch(() => {});
    });
  };
  const depensesExercice = depensesHt({
    frais: fraisTous,
    chantiers,
    achatsJoints,
    factures: facturesToutes,
    devis,
    employes: [],
    soc,
    salairesEstimes: salairesAnnee > 0,
    lppDansLesSalaires: salairesAnnee > 0 && +tauxCompta(soc, anneeC).lpp > 0,
  }).filter((l) => anneeDe({ date: l.date }) === anneeC);
  // Au magasin, la marchandise achetée (bons d'achat, dépenses « Matériel »,
  // compte 4000) est l'achat de marchandise : la carte restait à 0.
  const achatMarchandise = (l) => magC && l.genre === 'frais' && l.type === 'materiel';
  const achatsChantiersHt = depensesExercice
    .filter((l) => l.genre === 'fournisseur' || achatMarchandise(l))
    .reduce((s, l) => s + l.montant, 0);
  // Les véhicules : le leasing et l'amortissement se calculent sur leur fiche
  // (Compta → Véhicules). Une voiture achetée n'est pas une charge de l'année
  // où on la paie, et les paiements du leasing, gardés dans Dépenses pour la
  // banque et la TVA, ne comptent qu'une fois : par la fiche.
  const [vehicules, setVehicules] = useState([]);
  useEffect(() => {
    let actif = true;
    Promise.resolve()
      .then(() => vehiculesApi.liste())
      .then((v) => actif && setVehicules(v || []))
      .catch(() => {});
    return () => {
      actif = false;
    };
  }, []);
  const vehAnnee = vehiculesDeLAnnee(vehicules, anneeC);
  const avecLeasing = vehicules.some((v) => v.mode === 'LEASING');
  const parLaFicheVehicule = (type) =>
    type === 'achat_vehicule' || (avecLeasing && type === 'leasing');
  const fraisHt = depensesExercice
    .filter((l) => l.genre === 'frais' && !parLaFicheVehicule(l.type) && !achatMarchandise(l))
    .reduce((s, l) => s + l.montant, 0);
  // Un acompte encaissé cette année pour des travaux de l'année suivante,
  // rattaché à l'année des travaux : l'argent est en banque, mais ce n'est
  // pas encore un produit — c'est un acompte reçu d'avance, au passif.
  const acomptesAvance =
    (facturesToutes || [])
      .filter(
        (f) =>
          f.type === 'acompte' &&
          compteDansLeCa(f) &&
          anneeDe({ date: f.date }) === anneeC &&
          anneeDe(f) > anneeC,
      )
      .reduce((s, f) => s + htDocument(f), 0) +
    (regleAc(anneeC) === 'travaux' ? acomptesRecusDAvance(facturesToutes, paiements, anneeC) : 0);
  // Au magasin, la marchandise achetée et pas vendue reste au dépôt : la
  // hausse du stock de l'année sort des charges (elle y comptait en entier).
  const variationStock = magC ? variationDuStock({ stock, clotures, annee: anneeC }) : null;
  const resteAuDepot = variationStock ?? 0;

  // Debiteurs : ce que les clients doivent encore au 31.12 de l'exercice,
  // acomptes et avoirs deduits — une facture de decembre payee en janvier
  // reste due au bilan de decembre, une facture de l'an passe toujours due y
  // figure aussi.
  const toutesLesFactures = facturesToutes || factures;
  const debiteurs = debiteursAu31Decembre({
    factures: toutesLesFactures,
    paiements,
    annee: anneeC,
  });
  // Le stock au 31.12 : celui de la cloture, sinon (annee en cours) le depot
  // d'aujourd'hui, sinon celui retrouve depuis le journal du depot.
  const stockFin = stockAu31Decembre({ stock, clotures, annee: anneeC });
  const stockBilan = stockFin ?? 0;
  const stockDebutAn = stockAuDebut({ clotures, stock, annee: anneeC });

  // Les trois soldes que l'application ne peut pas deduire : ils sont saisis
  // pour chaque annee (au 31.12), et vivent dans les parametres, persistes.
  const soldesAn = soldesDeLAnnee(bilan, anneeC);
  const soldeBanque = soldesAn.banque ?? 0;
  const soldeCaisse = soldesAn.caisse ?? 0;
  const dettes = soldesAn.dettes ?? 0;

  /** Chiffres de l'exercice affiche, tels qu'ils seraient figes aujourd'hui. */
  const clotureDuJour = () =>
    composeCloture(
      anneeC,
      {
        ca: totalFacture,
        ventes: ventesHT,
        achats: achatsChantiersHt - resteAuDepot,
        frais: fraisHt,
        vehicules: vehAnnee.charge,
        salaires: masseSal,
        comptable: cptAn,
        banque: soldeBanque,
        caisse: soldeCaisse,
        debiteurs,
        stock: stockBilan,
        immobilisations: vehAnnee.achats + vehAnnee.leasingAvance,
        dettes,
        acomptesAvance,
      },
      today(),
    );

  /** Fige l'exercice affiche, ou le met a jour s'il l'etait deja. */
  const figeLExercice = () => {
    if (
      !window.confirm(
        "Clôturer l'exercice " +
          anneeC +
          ' ?\n\nLes chiffres seront figés pour ta déclaration. Une écriture ajoutée ensuite ne les modifiera plus.',
      )
    ) {
      return;
    }
    setReglageJson(CLE_CLOTURES, { ...clotures, [anneeC]: clotureDuJour() });
  };
  const moisLbl = [
    'Jan',
    'Fév',
    'Mar',
    'Avr',
    'Mai',
    'Jun',
    'Jui',
    'Aoû',
    'Sep',
    'Oct',
    'Nov',
    'Déc',
  ];
  const caMois = Array(12).fill(0);
  // Rangé comme l'exercice (l'année choisie d'un acompte), et les ventes de
  // la caisse comprises : le graphique oubliait la caisse et rangeait par la
  // date de la facture.
  const moisDe = (d) => {
    const m = String(d || '').match(/(\d{2})\.(\d{2})\./);
    return m ? +m[2] - 1 : -1;
  };
  factures.filter(compteDansLeCa).forEach((f) => {
    const mi = moisDe(f.dateCompta || f.date);
    if (mi >= 0 && mi < 12) caMois[mi] += ttcOf(f);
  });
  ventesExercice.forEach((v) => {
    const mi = moisDe(v.date);
    if (mi >= 0 && mi < 12) {
      caMois[mi] += htVente(v) * (1 + (v.tx != null ? +v.tx : tauxMagasin) / 100);
    }
  });
  const caMax = Math.max(1, ...caMois);
  // Un avoir n'est pas une creance : il ne figure pas dans ce qu'il reste a
  // encaisser.
  const echeancier = factures.filter(
    (f) =>
      f.type !== 'avoir' &&
      (f.statut === 'Envoyée' || f.statut === 'Partielle') &&
      !regleeParAvoir(f, toutesLesFactures),
  );
  // Ce qu'il reste a encaisser, et non ce qui a ete facture.
  const totalAVenir = echeancier.reduce((a, f) => a + soldeApresAvoirs(f, toutesLesFactures), 0);
  const remboursements = factures.reduce(
    (s, f) => s + (f.remboursement ? +f.remboursement.montant || 0 : 0),
    0,
  );
  const FREQ_MULT = { mensuel: 12, trimestriel: 4, semestriel: 2, annuel: 1 };
  const FREQ_LBL = {
    mensuel: 'par mois',
    trimestriel: 'par trimestre',
    semestriel: 'par semestre',
    annuel: 'par an',
  };
  const cpt = comptable;
  // Pas d'honoraires pour une année d'avant la première dépense notée : une
  // année de seuls acomptes reçus (2025) les comptait sans aucune pièce.
  const cptAn =
    cpt && anneeC >= premiereAnneeDuComptable(fraisTous)
      ? (+cpt.montant || 0) * (FREQ_MULT[cpt.freq] || 1)
      : 0;
  const soldeCpt = soldeComptable(cpt, anneeC);

  /** Pointe les règlements du comptable reconnus sur le relevé bancaire. */
  const pointeComptable = (reglements) => {
    if (!cpt || reglements.length === 0) return;
    const regle = { ...(cpt.paye || {}) };
    reglements.forEach(({ annee, periode }) => {
      regle[annee + '-' + periode] = true;
    });
    setReglageJson(CLE_COMPTABLE, { ...cpt, paye: regle });
  };

  /** Pointe ou depointe un reglement au comptable. */
  const basculePaiement = (periode) => {
    const regle = { ...((cpt && cpt.paye) || {}) };
    const cle = anneeC + '-' + periode;
    if (regle[cle]) {
      delete regle[cle];
    } else {
      regle[cle] = true;
    }
    setReglageJson(CLE_COMPTABLE, { ...(cpt || {}), paye: regle });
  };
  // Hors taxe, comme les factures auxquelles ces ventes s'ajoutent, et
  // limitees a l'exercice affiche : le compte de resultat melait jusqu'ici
  // toutes les ventes du magasin, tous exercices confondus, a des factures
  // filtrees sur l'annee.
  const ventesHT = ventesExercice.reduce((s, v) => s + htVente(v), 0);
  const produitsTot = totalFacture + ventesHT;
  const chargesTot =
    achatsChantiersHt - resteAuDepot + fraisHt + vehAnnee.charge + masseSal + cptAn;
  const resultat = produitsTot - chargesTot;
  const _byCli = {};
  factures.filter(compteDansLeCa).forEach((f) => {
    _byCli[f.clientId] = (_byCli[f.clientId] || 0) + signeCa(f) * htOf(f);
  });
  const topClients = Object.entries(_byCli)
    .map(([id, v]) => ({
      nom: ((clients || []).find((c) => c.id === +id) || {}).nom || 'Client',
      v,
    }))
    .sort((a, b) => b.v - a.v)
    .slice(0, 5);
  const _byProd = {};
  ventesExercice.forEach((v) => {
    const k = v.nom || 'Article';
    // Hors taxe, comme les lignes de facture auxquelles ce classement les
    // compare.
    _byProd[k] = (_byProd[k] || 0) + htVente(v);
  });
  // Les memes factures que le chiffre d'affaires : un brouillon — le modele
  // d'une facture recurrente en est un — n'a rien vendu, et le classement
  // comptait ses lignes une seconde fois.
  factures
    .filter((f) => compteDansLeCa(f) && f.type !== 'avoir')
    .forEach((f) =>
      (f.lignes || []).forEach((l) => {
        // La déduction d'un acompte (ligne négative) n'est pas un article
        // vendu : elle paraissait dans le classement, en négatif.
        if (String(l.cle || '').startsWith(PREFIXE_DEDUCTION)) return;
        const v = (+l.q || 0) * (+l.p || 0) * (1 - (+l.rem || 0) / 100);
        if (v <= 0) return;
        const k = l.d || l.nom || 'Article';
        _byProd[k] = (_byProd[k] || 0) + v;
      }),
    );
  const topProduits = Object.entries(_byProd)
    .map(([nom, v]) => ({ nom, v }))
    .sort((a, b) => b.v - a.v)
    .slice(0, 5);
  const cptDraftAn =
    (+('' + cptForm.montant).replace(',', '.') || 0) * (FREQ_MULT[cptForm.freq] || 1);
  return (
    <Shell
      active="plus"
      onNav={onNav}
      soc={soc}
      pageTitle="📊 Comptabilité"
      estMixte={estMixte}
      univers={univers}
      setUnivers={setUnivers}
    >
      {rapA4 ? <RapportComptaA4 data={rapA4} soc={soc} onClose={() => setRapA4(null)} /> : null}
      {clotureA4 ? (
        <ClotureA4 data={clotureA4} soc={soc} onClose={() => setClotureA4(null)} />
      ) : null}
      {anneesDispo.length > 1 && (
        <div
          style={{
            display: 'flex',
            gap: 6,
            alignItems: 'center',
            marginBottom: 10,
            flexWrap: 'wrap',
          }}
        >
          <span style={{ fontSize: 10, fontWeight: 700, color: C.muted }}>Exercice</span>
          {anneesDispo.map((an) => (
            <div
              key={an}
              onClick={() => setAnneeC(an)}
              style={{
                padding: '5px 11px',
                borderRadius: 8,
                fontSize: 10.5,
                fontWeight: 800,
                cursor: 'pointer',
                background: an === anneeC ? C.navy : C.white,
                color: an === anneeC ? '#fff' : C.muted,
                border: '1px solid ' + (an === anneeC ? C.navy : C.border),
              }}
            >
              {an}
            </div>
          ))}
        </div>
      )}
      <Tabs
        items={[
          ['synthese', 'Synthèse'],
          ['charges', '💰 Vue complète'],
          ['vehicules', '🚗 Véhicules'],
          ['classeur', '📁 Documents'],
          ['banque', '🏦 Banque'],
          ['echeancier', 'Échéancier'],
          ['tva', 'TVA'],
          ['journal', 'Journal'],
          ['bilan', 'Bilan'],
          // Les marges sont celles des chantiers ; le magasin suit les
          // siennes dans « Stock & ventes ».
          ...(magC ? [] : [['marges', 'Marges']]),
        ]}
        active={tab}
        onChange={setTab}
      />
      <div style={{ marginTop: 12 }} />
      {tab === 'vehicules' && (
        <VehiculesCompta vehicules={vehicules} setVehicules={setVehicules} annee={anneeC} />
      )}
      {tab === 'charges' &&
        (() => {
          const moisMin = periodeC === 's2' ? 6 : 0;
          const moisMax = periodeC === 's1' ? 5 : 11;
          const inP = (d) => {
            const m = (d || '').match(/(\d{2})\.(\d{2})\./);
            if (!m) return true;
            const mi = +m[2] - 1;
            return mi >= moisMin && mi <= moisMax;
          };
          // Les factures qui comptent, comme partout ailleurs : la vue complete
          // additionnait aussi les brouillons, les annulees et le modele des
          // factures recurrentes, et annoncait un chiffre d'affaires que ni la
          // synthese ni le decompte de TVA ne confirmaient. Un avoir se
          // retranche, au lieu d'etre ecarte.
          const facP = factures.filter((f) => compteDansLeCa(f) && inP(f.date));
          // Les ventes au comptoir de la periode comptent avec les factures :
          // la vue complete les oubliait, la synthese et l'onglet TVA non.
          const ventesP = ventesExercice.filter((v) => inP(v.date));
          const caVentesP = ventesP.reduce((a, v) => a + htVente(v), 0);
          const caP = facP.reduce((a, f) => a + signeCa(f) * htOf(f), 0) + caVentesP;
          // La TVA collectee est celle des documents, taux par ligne compris :
          // appliquer le taux du document a l'ensemble du hors-taxe fausse
          // toute facture qui en mele plusieurs.
          // Arrondie comme le decompte de l'onglet TVA — les factures au
          // centime, le comptoir au centime, puis la somme : sans cela les deux
          // ecrans annoncaient une TVA a payer differente d'un centime.
          // Comme le serveur : avoirs déduits, paiements partiels pour leur
          // part à l'encaissement, acompte à sa date.
          const tvaColLocale = decompteTva({
            factures: facturesToutes,
            paiements,
            dansLaPeriode: (d) => dansLExercice(d) && inP(d),
            ventes: ventesP,
            tauxVentes: tauxMagasin,
            methode: methodeTva,
          }).collectee;
          // Les dépenses de la période comme charges : une dépense répartie y
          // compte pour ses mois de la période (chargesDeLAnnee).
          const chargesP = chargesDeLAnnee.filter((x) => inP(x.date));
          // Les pièces du classeur qui ne viennent pas de la page Dépenses :
          // factures fournisseurs et sous-traitants des chantiers, achats
          // joints aux offres, honoraires du comptable. La liste ne lisait
          // que les Dépenses : « Matériel 112.90 » ici, 9'706.85 au classeur,
          // et pas de sous-traitance du tout. Mêmes pièces, mêmes règles de
          // doublon que le classeur ; le bénéfice, lui, les comptait déjà.
          const autresPiecesP = depensesDuClasseur({
            frais: fraisDeLAnnee,
            chantiers,
            achatsJoints,
            factures: facturesToutes,
            devis,
            comptable: cpt,
            annee: anneeC,
          }).flatMap(([type, arr]) =>
            arr
              .filter((it) => it.origine !== 'frais' && anneeDe(it) === anneeC && inP(it.date))
              .map((it) => ({ ...it, type })),
          );
          const depensesP = [...chargesP, ...autresPiecesP];
          const libDuType = (t) => (FRAIS_CAT[t] || TYPES_DU_CLASSEUR[t] || {}).lib || t || 'Autre';
          const fraisP = depensesP.reduce((a, x) => a + (+x.montant || 0), 0);
          const fraisParCat = {};
          depensesP.forEach((x) => {
            const c = libDuType(x.type);
            fraisParCat[c] = (fraisParCat[c] || 0) + (+x.montant || 0);
          });
          // Les factures des fournisseurs et les sous-traitants des chantiers,
          // les achats joints aux offres : des achats de l'entreprise, comptés
          // une seule fois avec les dépenses (mêmes pièces que le classeur et
          // que la position TVA du serveur). Le calcul local n'ajoutait que
          // les factures des chantiers, sans les sous-traitants.
          const achatsChantiersP = autresPiecesP
            .filter((x) => x.type !== 'comptable' && !x.sansFacture)
            .reduce((a, x) => a + (+x.montant || 0), 0);
          // Le prix convenu d'un sous-traitant pas encore facturé : un coût,
          // hors TVA estimée, mais hors de la position TVA (pas de facture,
          // pas de TVA à récupérer). Il s'ajoute au coût à part.
          const nonFacturesHtP = autresPiecesP
            .filter((x) => x.sansFacture)
            .reduce(
              (a, x) =>
                a +
                (+x.montant || 0) -
                tvaFactureFournisseur({ montant: +x.montant || 0, date: x.date }, soc),
              0,
            );
          const catsList = Object.entries(fraisParCat).sort((a, b) => b[1] - a[1]);
          const GRP = {
            soustraitance: '📦 Achats & sous-traitance',
            materiel: '📦 Achats & sous-traitance',
            facture: '📦 Achats & sous-traitance',
            vehicule: '🚗 Véhicule',
            leasing: '🚗 Véhicule',
            achat_vehicule: '🚗 Véhicule',
            reparation: '🚗 Véhicule',
            loc_voiture: '🚗 Véhicule',
            stationnement: '🚗 Véhicule',
            transports: '🚗 Véhicule',
            loyer: '🏢 Locaux & bureau',
            location_bail: '🏢 Locaux & bureau',
            energie: '🏢 Locaux & bureau',
            menage: '🏢 Locaux & bureau',
            fournitures: '🏢 Locaux & bureau',
            communications: '🏢 Locaux & bureau',
            admin: '🏢 Locaux & bureau',
            port: '🏢 Locaux & bureau',
            assurance: '💼 Frais généraux',
            comptable: '💼 Frais généraux',
            bancaire: '💼 Frais généraux',
            interets: '💼 Frais généraux',
            pub: '💼 Frais généraux',
            dons: '💼 Frais généraux',
            formation: '💼 Frais généraux',
            repas: '🍽️ Repas & cafés',
            voyage: '✈️ Déplacements',
            billets_avion: '✈️ Déplacements',
            logement: '✈️ Déplacements',
            cafe: '🍽️ Repas & cafés',
            nourriture: '🍽️ Repas & cafés',
            epicerie: '🍽️ Repas & cafés',
            vetements: '📋 Divers',
            sante: '📋 Divers',
            divertissements: '📋 Divers',
          };
          // Les mois d'un même paiement réparti, sur une seule ligne.
          const grpData = {};
          [...regroupeLesParts(chargesP), ...autresPiecesP].forEach((x) => {
            const g = GRP[x.type] || '📋 Divers';
            if (!grpData[g]) grpData[g] = [];
            grpData[g].push(x);
          });
          const grpOrder = [
            '📦 Achats & sous-traitance',
            '🚗 Véhicule',
            '🏢 Locaux & bureau',
            '💼 Frais généraux',
            // Les repas et les cafés à part des voyages : « Déplacements &
            // repas » s'affichait au-dessus de deux cafés et d'un repas.
            '🍽️ Repas & cafés',
            '✈️ Déplacements',
            '📋 Divers',
          ].filter((g) => grpData[g]);
          // Chaque depense porte le taux de sa famille : appliquer le taux
          // normal a tout reclamait a l'AFC une deduction que l'entreprise
          // n'a pas.
          const tvaDedLocale = auCentime(
            tvaRecuperable(
              (frais || []).filter((x) => inP(x.dateCompta || x.date)),
              FRAIS_CAT,
              soc,
            ),
          );
          // La position TVA du serveur fait foi — avoirs, factures
          // fournisseurs des chantiers et TVA saisie compris — ; le calcul
          // local ne sert qu'en attendant sa réponse ou hors ligne.
          const posP =
            positionPeriode && positionPeriode.cle === anneeC + '-' + periodeC
              ? positionPeriode.position
              : null;
          const tvaColP = posP ? +posP.facturee.total : tvaColLocale;
          const tvaDedP = posP ? +posP.recuperable.total : tvaDedLocale;
          const tvaP = auCentime(tvaColP - tvaDedP);
          // Les salaires réellement dus sur la période, mois écoulés : les
          // heures pointées au taux horaire, sinon le salaire mensuel — la
          // règle de la fiche de salaire. Le salaire mensuel multiplié par
          // le nombre de mois comptait pour zéro un employé payé à l'heure.
          // Le patron indépendant ne se verse pas de salaire : son revenu
          // est le bénéfice.
          const moisP = moisDeLaPeriode(anneeC, periodeC);
          const nbMois = moisP.length;
          const salP = salairesDeLaPeriode({
            employes,
            chantiers,
            mois: moisP,
            soc,
            exclu: (e) =>
              e?.patronIndependant || (estIndependant(soc?.forme) && maFiche.estLaMienne(e)),
          });
          // Achats et frais hors TVA récupérable : la TVA payée se récupère,
          // elle n'est pas une charge.
          // Les achats TTC et la TVA récupérable sont ceux des paiements, à
          // leur date (la position TVA du serveur ne répartit rien).
          const paiementsP = (frais || []).filter((x) => inP(x.date));
          const achatsTtcP = posP
            ? +posP.recuperable.achatsTtc
            : paiementsP.reduce((a, x) => a + (+x.montant || 0), 0) + achatsChantiersP;
          // Achat d'une voiture et leasing : comptés par la fiche du véhicule.
          const htDe = (liste) =>
            liste
              .filter((x) => !parLaFicheVehicule(x.type))
              .reduce((s, x) => s + (+x.montant || 0) - tvaDeLaDepense(x, FRAIS_CAT, soc), 0);
          const parLaFicheP = paiementsP
            .filter((x) => parLaFicheVehicule(x.type))
            .reduce((s, x) => s + (+x.montant || 0) - tvaDeLaDepense(x, FRAIS_CAT, soc), 0);
          // Une dépense répartie compte, hors TVA, pour ses mois de la
          // période plutôt qu'en entier le jour du paiement : l'écart entre
          // les deux corrige la charge. Sans dépense répartie, il est nul.
          const ecartRepartiP = htDe(chargesP) - htDe(paiementsP);
          // Les charges des salaires sont estimées plus bas (AVS, LPP…) : la
          // facture de la caisse AVS et celle de la caisse de pension sortent
          // du compte, mais ne coûtent pas une seconde fois — la règle de la
          // Synthèse et de l'accueil. La vue complète les comptait deux fois :
          // 7'000.– de bénéfice en moins pour 7'000.– de caisses payées.
          const dejaEstimeesP =
            salP > 0
              ? paiementsP
                  .filter(
                    (x) =>
                      x.type === 'charges_sociales' ||
                      (x.type === 'lpp' && +tauxCompta(soc, anneeC).lpp > 0),
                  )
                  .reduce((s, x) => s + (+x.montant || 0) - tvaDeLaDepense(x, FRAIS_CAT, soc), 0)
              : 0;
          const achatsHtP = Math.max(
            0,
            achatsTtcP - tvaDedP - parLaFicheP + ecartRepartiP - dejaEstimeesP + nonFacturesHtP,
          );
          // Le comptable et les véhicules sont des charges de l'année, comme
          // dans la Synthèse et l'onglet Véhicules : l'année entière, ou sa
          // moitié pour un semestre. Ramenés aux mois écoulés, ils donnaient
          // un autre bénéfice que la Synthèse pour la même année.
          const partPeriode = periodeC === 'annee' ? 1 : 0.5;
          const cptP = cptAn * partPeriode;
          // Un seul jeu de taux pour l'équipe et la comptabilité : AVS, AC,
          // LAA, AF, frais d'administration et IJM viennent du barème de la
          // paie de l'exercice (Réglages → Charges sociales), le reste de
          // `soc.tauxCompta`.
          const TX = tauxCompta(soc, anneeC);
          const rAVS = TX.avs,
            rAC = TX.ac,
            rLAA = TX.laa,
            rMal = TX.ijm,
            rAdmin = TX.admin,
            rLPP = TX.lpp,
            rAF = TX.af;
          const cAVS = (salP * rAVS) / 100,
            cAC = (salP * rAC) / 100,
            cLAA = (salP * rLAA) / 100,
            cMal = (salP * rMal) / 100,
            cAdmin = (salP * rAdmin) / 100,
            cLPP = (salP * rLPP) / 100,
            cAF = (salP * rAF) / 100,
            rCanton = +TX.canton || 0,
            cCanton = (salP * rCanton) / 100;
          // Les charges de la CCT du bâtiment sont celles de la société, non
          // de l'univers affiché : une société Mix les doit, que la bascule
          // montre le magasin ou les chantiers. `soc.secteur` est réécrit par
          // l'univers en Mix ; c'est `estMixte` qui dit la société.
          const estBat = modulesSouscrits(estMixte ? 'mixte' : soc?.secteur).batiment;
          const rCCT = TX.cct,
            rRet = TX.retabat;
          const cCCT = estBat ? (salP * rCCT) / 100 : 0,
            cRet = estBat ? (salP * rRet) / 100 : 0;
          // Les cotisations du canton sont des charges patronales, comme dans
          // la Synthèse et la carte « Charges sociales » juste en dessous.
          const chSocP = cAVS + cAC + cLAA + cMal + cAdmin + cLPP + cAF + cCanton + cCCT + cRet;
          const capital = +(soc?.capital ?? 20000),
            rCap = TX.impotCapital;
          const vehiculesP = vehAnnee.charge * partPeriode;
          const benef = caP - achatsHtP - vehiculesP - salP - chSocP - cptP;
          const txIS = TX.impotSociete;
          // L'indépendant ne paie pas d'impôt de société : l'AVS et l'impôt
          // sur le revenu, sur son bénéfice. Même calcul que l'accueil.
          const impots = impotsAProvisionner({
            benefice: benef,
            independant: estIndependant(soc?.forme),
            TX,
            capital,
            partAnnee: periodeC === 'annee' ? 1 : 0.5,
            annee: anneeC,
          });
          const impot = impots.independant ? impots.total : impots.societe;
          const impotCap = impots.capital;
          const totalDu = tvaP + chSocP + impot + impotCap;
          // Les paiements à l'État de l'exercice et de la période, comme l'accueil.
          const verse = dejaPayeEtat(fraisTous, (d) => anneeDe({ date: d }) === anneeC && inP(d));
          const dejaVerse = auCentime(verse.tva + verse.avs + verse.impots);
          const R = ({ label, val, col, strong }) => (
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                padding: '11px 0',
                borderBottom: '1px solid #f0f2f5',
              }}
            >
              <span
                style={{
                  fontSize: strong ? 13 : 12,
                  fontWeight: strong ? 800 : 600,
                  color: col || C.ink,
                }}
              >
                {label}
              </span>
              <span
                style={{
                  fontSize: strong ? 15 : 13,
                  fontWeight: strong ? 900 : 700,
                  color: col || C.ink,
                }}
              >
                {DEVISE + ' ' + fmt(val)}
              </span>
            </div>
          );
          return (
            <div>
              <div style={{ display: 'flex', gap: 6, marginBottom: 12 }}>
                {[
                  ['annee', 'Année'],
                  ['s1', '1er semestre'],
                  ['s2', '2e semestre'],
                ].map(([v, l]) => {
                  const on = periodeC === v;
                  return (
                    <div
                      key={v}
                      onClick={() => setPeriodeC(v)}
                      style={{
                        flex: 1,
                        textAlign: 'center',
                        cursor: 'pointer',
                        border: '1px solid ' + (on ? C.ink : C.border),
                        borderRadius: 9,
                        padding: '9px',
                        fontSize: 11,
                        fontWeight: 800,
                        background: on ? C.navy : '#fff',
                        color: on ? '#fff' : C.grey,
                      }}
                    >
                      {l}
                    </div>
                  );
                })}
              </div>
              <Card style={{ marginBottom: 12 }}>
                <Bar
                  icon="⬇"
                  title="Revenus — ce que j'ai facturé"
                  color={C.green}
                  sub="Chiffre d'affaires de la période (HT)"
                />
                <div style={{ padding: '4px 15px 12px' }}>
                  <details>
                    <summary
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        padding: '6px 0',
                        fontSize: 12,
                        cursor: 'pointer',
                        listStyle: 'none',
                      }}
                    >
                      <span style={{ color: C.ink, fontWeight: 600 }}>
                        ▸ Factures clients + ventes (HT)
                      </span>
                      <b style={{ color: C.green }}>{DEVISE + ' ' + fmt(caP)}</b>
                    </summary>
                    <div style={{ padding: '0 0 4px 14px' }}>
                      {facP.length === 0 ? (
                        <div style={{ fontSize: 9, color: C.muted, padding: '2px 0' }}>
                          Aucune facture sur la période
                        </div>
                      ) : (
                        facP.map((f, j) => {
                          const cl = (clients || []).find((c) => c.id === f.clientId);
                          return (
                            <div
                              key={j}
                              style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                fontSize: 9.5,
                                color: C.grey,
                                padding: '3px 0',
                                borderTop: '1px solid #f6f8fa',
                              }}
                            >
                              <span>
                                {f.date}
                                {cl ? ' · ' + cl.nom : ''}
                                {f.num ? ' · ' + f.num : ''}
                              </span>
                              <span style={{ fontWeight: 700 }}>
                                {DEVISE + ' ' + fmt(signeCa(f) * htOf(f))}
                              </span>
                            </div>
                          );
                        })
                      )}
                    </div>
                  </details>
                </div>
              </Card>
              <Card style={{ marginBottom: 12 }}>
                <Bar icon="🧾" title="TVA" color={C.teal} />
                <div style={{ padding: '4px 15px 12px' }}>
                  <R
                    label={methodeTva === 'recues' ? 'TVA facturée (encaissée)' : 'TVA facturée'}
                    val={tvaColP}
                    col={C.green}
                  />
                  <R label="TVA sur achats/frais (déductible)" val={tvaDedP} col={C.red} />
                  {tvaP >= 0 ? (
                    <R label="TVA à payer à l'AFC" val={tvaP} col={C.teal} strong />
                  ) : (
                    <R label="TVA à récupérer (crédit AFC)" val={-tvaP} col={C.green} strong />
                  )}
                </div>
              </Card>
              <Card style={{ marginBottom: 12 }}>
                <Bar
                  icon="👷"
                  title="Salaires & charges sociales"
                  color={C.navy}
                  sub={'Sur ' + nbMois + ' mois \u00b7 part employeur'}
                />
                <div style={{ padding: '4px 15px 12px' }}>
                  <R label={'Salaires bruts (' + nbMois + ' mois)'} val={salP} />
                  <R label={'AVS / AI / APG (' + rAVS + '%)'} val={cAVS} />
                  <R label={'AC \u2014 ch\u00f4mage (' + rAC + '%)'} val={cAC} />
                  <R label={'LAA \u2014 accident (' + rLAA + '%)'} val={cLAA} />
                  {cMal > 0 && <R label={'IJM \u2014 maladie (' + rMal + '%)'} val={cMal} />}
                  <R label={'LPP \u2014 2e pilier (' + rLPP + '%)'} val={cLPP} />
                  <R label={'Allocations familiales (' + rAF + '%)'} val={cAF} />
                  <R label={"Frais d'administration (" + rAdmin + '%)'} val={cAdmin} />
                  {cCanton > 0 && (
                    <R label={'Cotisations du canton (' + rCanton + '%)'} val={cCanton} />
                  )}
                  {estBat && (
                    <R label={'CCT / Parifonds b\u00e2timent (' + rCCT + '%)'} val={cCCT} />
                  )}
                  {estBat && <R label={'RETABAT b\u00e2timent (' + rRet + '%)'} val={cRet} />}
                  <R label="Total charges patronales" val={chSocP} col={C.amber} strong />
                </div>
              </Card>
              <Card style={{ marginBottom: 12 }}>
                <Bar
                  icon="🧾"
                  title="Dépenses par catégorie"
                  color={C.red}
                  sub={tr('Toutes tes dépenses sur la période, comme dans le classeur')}
                />
                <div style={{ padding: '4px 15px 12px' }}>
                  {grpOrder.length === 0 ? (
                    <div style={{ padding: 12, textAlign: 'center', color: C.muted, fontSize: 11 }}>
                      Aucune dépense sur la période. Ajoute-les dans l'onglet « Frais ».
                    </div>
                  ) : (
                    grpOrder.map((g, gi) => {
                      const gitems = grpData[g];
                      const parCat = {};
                      gitems.forEach((x) => {
                        const lib = libDuType(x.type);
                        if (!parCat[lib]) parCat[lib] = [];
                        parCat[lib].push(x);
                      });
                      const gTot = gitems.reduce((a, x) => a + (+x.montant || 0), 0);
                      return (
                        <div key={gi} style={{ marginBottom: 8 }}>
                          <div
                            style={{
                              fontSize: 10,
                              fontWeight: 800,
                              color: C.navy,
                              background: C.navyXL || '#eef1f6',
                              borderRadius: 7,
                              padding: '6px 10px',
                              marginBottom: 2,
                              display: 'flex',
                              justifyContent: 'space-between',
                            }}
                          >
                            <span>{tr(g)}</span>
                            <span>{DEVISE + ' ' + fmt(gTot)}</span>
                          </div>
                          {Object.entries(parCat)
                            .sort(
                              (a, b) =>
                                b[1].reduce((s, x) => s + (+x.montant || 0), 0) -
                                a[1].reduce((s, x) => s + (+x.montant || 0), 0),
                            )
                            .map(([lib, arr], i) => {
                              const v = arr.reduce((s, x) => s + (+x.montant || 0), 0);
                              return (
                                <details key={i} style={{ borderBottom: '1px solid ' + C.line }}>
                                  <summary
                                    style={{
                                      display: 'flex',
                                      justifyContent: 'space-between',
                                      alignItems: 'center',
                                      padding: '7px 4px',
                                      fontSize: 11.5,
                                      cursor: 'pointer',
                                      listStyle: 'none',
                                    }}
                                  >
                                    <span style={{ color: C.ink, fontWeight: 600 }}>▸ {lib}</span>
                                    <b>{DEVISE + ' ' + fmt(v)}</b>
                                  </summary>
                                  <div style={{ padding: '0 4px 8px 16px' }}>
                                    {arr.map((it, j) => (
                                      <div
                                        key={j}
                                        style={{
                                          display: 'flex',
                                          justifyContent: 'space-between',
                                          fontSize: 9.5,
                                          color: C.grey,
                                          padding: '3px 0',
                                          borderTop: '1px solid #f6f8fa',
                                        }}
                                      >
                                        <span>
                                          {it.date}
                                          {it.fournisseur ? ' · ' + it.fournisseur : ''}
                                          {it.photo ? ' 📎' : ''}
                                          {it.nbMois
                                            ? ' · ' + trf('🔁 {0} mois sur {1}', it.nbMois, it.sur)
                                            : ''}
                                        </span>
                                        <span style={{ fontWeight: 700 }}>
                                          {DEVISE + ' ' + fmt(+it.montant || 0)}
                                        </span>
                                      </div>
                                    ))}
                                  </div>
                                </details>
                              );
                            })}
                        </div>
                      );
                    })
                  )}
                  {fraisP > 0 && <R label="TOTAL DÉPENSES" val={fraisP} col={C.red} strong />}
                </div>
              </Card>
              <Card style={{ marginBottom: 12 }}>
                <Bar
                  icon="💰"
                  title={impots.independant ? 'Bénéfice & impôts' : 'Bénéfice & impôt société'}
                  color={C.purple}
                  sub={
                    impots.independant
                      ? trf(
                          'Indépendant · AVS {0} % · impôt sur le revenu {1} %',
                          // Le taux réellement appliqué, comme l'accueil : le
                          // barème dégressif le baisse sous 60'500.– de revenu.
                          // « AVS 10 % » ici, « AVS (9 %) » sur l'accueil.
                          impots.base > 0
                            ? Math.round((impots.avs / impots.base) * 1000) / 10
                            : TX.avsIndependant,
                          TX.impotRevenu,
                        )
                      : 'Impôt estimé · taux ' + txIS + '%'
                  }
                />
                <div style={{ padding: '4px 15px 12px' }}>
                  <R label="Matériel / frais (hors TVA)" val={achatsHtP} col={C.red} />
                  {achatsChantiersP > 0 && (
                    <div style={{ fontSize: 9, color: C.grey, margin: '-4px 0 6px' }}>
                      {trf(
                        'dont factures fournisseurs : {0} TTC',
                        DEVISE + ' ' + fmt(achatsChantiersP),
                      )}
                    </div>
                  )}
                  {vehiculesP > 0 && (
                    <R
                      label="🚗 Véhicules (leasing + amortissement)"
                      val={vehiculesP}
                      col={C.red}
                    />
                  )}
                  <R label="Salaires + charges" val={salP + chSocP} col={C.red} />
                  {cptP > 0 && <R label="Comptable / fiduciaire" val={cptP} col={C.red} />}
                  <R label="= Bénéfice" val={benef} col={benef >= 0 ? C.green : C.red} strong />
                  {impots.independant ? (
                    <>
                      <R label="AVS / AI / APG indépendant" val={impots.avs} col={C.purple} />
                      <R
                        label="Impôt sur le revenu (estimation)"
                        val={impots.revenu}
                        col={C.purple}
                        strong
                      />
                    </>
                  ) : (
                    <>
                      <R label="Impôt société (estimation)" val={impot} col={C.purple} strong />
                      <R
                        label={'Imp\u00f4t sur le capital (' + rCap + '% de ' + fmt(capital) + ')'}
                        val={impotCap}
                        col={C.purple}
                      />
                    </>
                  )}
                </div>
              </Card>
              <div
                style={{
                  background: 'linear-gradient(135deg,' + C.navy + ',' + C.navyM + ')',
                  color: '#fff',
                  borderRadius: 14,
                  padding: '16px',
                }}
              >
                <div style={{ fontSize: 11, color: 'rgba(255,255,255,.75)', fontWeight: 700 }}>
                  TOTAL À PAYER (
                  {periodeC === 'annee' ? 'année' : periodeC === 's1' ? '1er sem.' : '2e sem.'})
                </div>
                <div style={{ fontSize: 26, fontWeight: 900, marginTop: 4 }}>
                  {DEVISE + ' ' + fmt(totalDu)}
                </div>
                {/* Ce qui est déjà versé (Dépenses → Payé à l'État) et le reste,
                    comme « Ce que je dois à l'État » sur l'accueil : 15'640.32
                    ici, « reste 12'569.17 » là-bas, sans dire pourquoi. */}
                {dejaVerse > 0.005 && (
                  <div style={{ fontSize: 11, fontWeight: 700, marginTop: 4 }}>
                    {trf(
                      'Déjà payé {0} · reste {1}',
                      DEVISE + ' ' + fmt(dejaVerse),
                      DEVISE + ' ' + fmt(totalDu - dejaVerse),
                    )}
                  </div>
                )}
                {/* Deux guichets, deux paiements : l'État (TVA, impôts, AVS de
                    l'indépendant) et les caisses sociales (AVS des salaires,
                    LPP, accidents, CCT…). Un seul total les mêlait. */}
                <div
                  style={{
                    display: 'grid',
                    gridTemplateColumns: '1fr 1fr',
                    gap: 8,
                    marginTop: 10,
                  }}
                >
                  {[
                    [
                      '🏛️ ' + tr('État'),
                      tvaP + impot + impotCap,
                      impots.independant
                        ? tr('TVA + AVS indépendant + impôts')
                        : tr('TVA + impôts'),
                    ],
                    [
                      '👷 ' + tr('Caisses sociales'),
                      chSocP,
                      tr('AVS des salaires, LPP, accidents, CCT…'),
                    ],
                  ].map(([titre, montant, detail]) => (
                    <div
                      key={titre}
                      style={{
                        background: 'rgba(255,255,255,.1)',
                        borderRadius: 10,
                        padding: '8px 10px',
                      }}
                    >
                      <div style={{ fontSize: 10, fontWeight: 700 }}>{titre}</div>
                      <div style={{ fontSize: 15, fontWeight: 900, marginTop: 2 }}>
                        {DEVISE + ' ' + fmt(montant)}
                      </div>
                      <div style={{ fontSize: 8.5, color: 'rgba(255,255,255,.65)', marginTop: 2 }}>
                        {detail}
                      </div>
                    </div>
                  ))}
                </div>
                <div style={{ fontSize: 9, color: 'rgba(255,255,255,.6)', marginTop: 6 }}>
                  {impots.independant
                    ? 'TVA + charges sociales + AVS et impôt sur le revenu'
                    : 'TVA + charges sociales + impôt société'}
                </div>
              </div>
              <div style={{ marginTop: 12 }}>
                <Btn
                  label="📄 Voir / Imprimer le rapport en A4"
                  color={C.navy}
                  full
                  onClick={() =>
                    setRapA4({
                      periode: periodeC,
                      tvaColP,
                      tvaDedP,
                      tvaP,
                      salP,
                      cAVS,
                      cAC,
                      cLAA,
                      cMal,
                      cLPP,
                      cAF,
                      cAdmin,
                      cCanton,
                      cCCT,
                      cRet,
                      chSocP,
                      caP,
                      fraisP,
                      catsList,
                      benef,
                      impot,
                      impotCap,
                      impots,
                      totalDu,
                    })
                  }
                />
              </div>
              <Card style={{ marginTop: 12 }}>
                <Bar
                  icon="🏛"
                  title={'Charges sociales ' + anneeC}
                  color={C.amber}
                  sub="Les taux de la paie, réglés par année"
                />
                <div style={{ padding: 13 }}>
                  <ApercuCharges soc={soc} annee={anneeC} onNav={onNav} />
                </div>
              </Card>
              <Card style={{ marginTop: 12 }}>
                <Bar
                  icon="⚙️"
                  title="Autres taux de l'estimation"
                  color={C.grey}
                  sub="Adapte selon tes caisses et ton canton"
                />
                <div
                  style={{ padding: 13, display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 9 }}
                >
                  {[
                    ['lpp', 'LPP 2e pilier (moyenne)'],
                    ['cct', 'CCT/Parifonds'],
                    ['retabat', 'RETABAT'],
                    ['impotCapital', 'Imp\u00f4t capital'],
                    ['impotSociete', 'Imp\u00f4t soci\u00e9t\u00e9'],
                    ['avsIndependant', 'AVS indépendant'],
                    ['impotRevenu', 'Impôt sur le revenu (indépendant)'],
                  ].map(([k, l]) => (
                    <CaseTauxVerifiee
                      key={k}
                      libelle={l}
                      valeur={TX[k]}
                      defaut={tauxComptaParDefaut(soc)[k]}
                      inhabituel={TAUX_COMPTA_INHABITUELS[k]}
                      onChange={(n) => setSoc((p) => ({ ...p, ...tauxComptaModifies(p, k, n) }))}
                      onRemettre={() => setSoc((p) => ({ ...p, ...tauxComptaRemis(p, k) }))}
                    />
                  ))}
                </div>
                {Object.keys((soc && soc.tauxCompta) || {}).length > 0 && (
                  <div style={{ padding: '0 13px 13px' }}>
                    <Btn
                      label={'↺ ' + tr('Remettre tous ces taux par défaut')}
                      sm
                      ghost
                      color={C.grey}
                      full
                      onClick={() => {
                        if (window.confirm(tr('Remettre tous ces taux à leur valeur par défaut ?')))
                          setSoc((p) => ({ ...p, ...tauxComptaRemis(p) }));
                      }}
                    />
                  </div>
                )}
              </Card>
              <Card style={{ marginTop: 12 }}>
                <Bar
                  icon="🏦"
                  title="Capital de la société"
                  color={C.grey}
                  sub="Pour l'impôt sur le capital"
                />
                <div style={{ padding: 13 }}>
                  <div style={{ fontSize: 8, fontWeight: 800, color: C.muted, marginBottom: 4 }}>
                    CAPITAL (CHF)
                  </div>
                  <input
                    type="number"
                    value={soc?.capital ?? 20000}
                    onChange={(e) => setSoc((p) => ({ ...p, capital: +e.target.value || 0 }))}
                    style={{
                      width: '100%',
                      border: '1px solid ' + C.border,
                      borderRadius: 8,
                      padding: '9px',
                      fontSize: 13,
                      boxSizing: 'border-box',
                    }}
                  />
                </div>
              </Card>
              <div
                style={{
                  fontSize: 8.5,
                  color: C.muted,
                  marginTop: 10,
                  textAlign: 'center',
                  lineHeight: 1.5,
                }}
              >
                💡 Estimations à partir de tes données. Les taux exacts (LAA, LPP, impôt cantonal)
                se règlent ci-dessus. Les décomptes officiels viennent de tes caisses et de la
                fiduciaire.
              </div>
            </div>
          );
        })()}
      {tab === 'banque' && (
        <div>
          {/* Les paiements des factures (camt.054) : déplacés ici depuis la
              page des factures, à côté du relevé complet du compte. */}
          {setFactures && (
            <PaiementsFactures
              factures={facturesToutes || []}
              setFactures={setFactures}
              clients={clients || []}
              paiements={paiements}
            />
          )}
          <label
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 9,
              background: C.teal + '12',
              border: '1px solid ' + C.teal,
              borderRadius: 12,
              padding: '12px 14px',
              cursor: 'pointer',
              marginBottom: 12,
            }}
          >
            <span style={{ fontSize: 18 }}>🏦</span>
            <div style={{ flex: 1 }}>
              <div style={{ fontSize: 12, fontWeight: 800, color: C.teal }}>
                {tr('Importer le relevé bancaire (PDF ou camt.053)')}
              </div>
              <div style={{ fontSize: 8.5, color: C.muted }}>
                Le relevé complet du compte (entrées + sorties), depuis ton e-banking
              </div>
              {/* Le bouton ouvre les fichiers du téléphone : sans relevé
                  téléchargé auparavant, rien à choisir, et l'import paraissait
                  ne pas marcher. */}
              <div style={{ fontSize: 9, color: C.grey, marginTop: 4, lineHeight: 1.4 }}>
                {tr(
                  'D’abord, télécharge le relevé dans ton e-banking (menu Relevés ou Export) : en PDF, ou mieux au format camt.053 (XML). Ensuite, touche ici et choisis ce fichier. Une photo ne marche pas.',
                )}
              </div>
            </div>
            <input
              type="file"
              accept=".xml,text/xml,application/xml,.pdf,application/pdf"
              style={{ display: 'none' }}
              onChange={(e) => {
                const f = e.target.files && e.target.files[0];
                if (f) {
                  const alerte = (texte) => {
                    try {
                      window.alert(texte);
                    } catch (_) {}
                  };
                  // Les mouvements lus, du camt.053 ou du PDF (même forme) :
                  // le relevé est gardé, puis rapproché des factures et des
                  // dépenses. `lu` : ce qui a été lu dans le PDF, à vérifier ;
                  // `soldes` : ses soldes d'ouverture et de clôture, s'il les dit.
                  // `banque` : celle que le fichier nomme, ou ''.
                  const importe = (lus, lu, soldes = {}, banque = '') => {
                    // Le fichier lui-même est gardé par le serveur, tel que
                    // transmis : le classeur le montre et l'envoie à la
                    // comptable. Le même fichier réimporté ne fait pas un
                    // second relevé.
                    if (soc?.id != null) {
                      gardeLeReleve(f, lus, banque).catch((err) => {
                        if (!err?.dejaAffiche) {
                          alerte(
                            trf(
                              'Le fichier du relevé n’a pas pu être gardé : {0}',
                              err?.message || '',
                            ),
                          );
                        }
                      });
                    }
                    // Le nouveau relevé s'ajoute à ceux déjà importés :
                    // octobre ne chasse plus septembre. Seuls les mouvements
                    // nouveaux se rapprochent — réimporter le même relevé ne
                    // compte pas deux fois un paiement. Le même paiement lu
                    // dans un autre format (le camt, puis le PDF) n'est pas
                    // rapproché : il attend que le patron dise s'il est en double.
                    const {
                      nouveaux: tx,
                      douteux,
                      deja,
                    } = fusionneReleves(soc?.releveBancaire, lus, soldes);
                    // Le comptable payé par bulletin de versement : son
                    // paiement se reconnaît sur le relevé et se pointe seul.
                    const reglements = rapprocheSorties(tx, { comptable: cpt }).filter(
                      (l) => l?.genre === 'comptable',
                    );
                    pointeComptable(reglements);
                    // Chaque dépense, facture de fournisseur, sous-traitant ou
                    // pièce jointe reconnue prend le jour de sa sortie, payée
                    // par la banque ; une date déjà notée n'est jamais remplacée.
                    const { aDater, aVerifier } = paiementsDuReleve(
                      tx,
                      rapprocheSorties(tx, {
                        comptable: cpt,
                        chantiers,
                        frais: fraisTous,
                        achats: achatsJoints,
                      }),
                    );
                    dateLesPaiements(aDater);
                    // L'argent reçu : chaque paiement reconnu (référence du
                    // QR, ou montant exact et nom du client) marque sa facture
                    // payée — l'accueil, la comptabilité et la TVA suivent.
                    // Un paiement déjà noté sur la facture (même jour, même
                    // montant) ne s'encaisse pas une seconde fois.
                    const encaissements = peutEncaisser()
                      ? encaissementsDuReleve(tx, facturesToutes, clients, soc?.releveBancaire)
                      : [];
                    if (encaissements.length && setFactures) {
                      setFactures((p) =>
                        p.map((x) => {
                          const e = encaissements.find((l) => l.facture.id === x.id);
                          return e
                            ? factureApresPaiement(x, e.t.montant, isoVersDate(e.t.date), p)
                            : x;
                        }),
                      );
                    }
                    // Chaque paiement reconnu reste noté sur sa ligne du
                    // relevé : il ne se propose plus une seconde fois.
                    const payeePar = new Map(
                      encaissements.map((e) => [cleMouvement(e.t), e.facture.id]),
                    );
                    setSoc((p) => ({
                      ...p,
                      releveBancaire: fusionneReleves(
                        p?.releveBancaire,
                        lus,
                        soldes,
                      ).mouvements.map((t) =>
                        payeePar.has(cleMouvement(t))
                          ? { ...t, factureId: payeePar.get(cleMouvement(t)) }
                          : t,
                      ),
                    }));
                    // Le contrôle du relevé lu : solde initial + entrées −
                    // sorties = solde final, quand il dit ses soldes.
                    const controle = totauxDuReleve(fusionneReleves([], lus, soldes).mouvements);
                    const aVoir = douteux.length + tx.filter((t) => !sensConnu(t)).length;
                    try {
                      const bilan =
                        trf(
                          '✓ Relevé importé : {0} nouveau(x) mouvement(s) ajouté(s), {1} déjà là.',
                          tx.length,
                          deja,
                        ) +
                        (encaissements.length
                          ? '\n' + encaissements.length + ' facture(s) marquée(s) payée(s).'
                          : '') +
                        (reglements.length
                          ? '\n' + reglements.length + ' paiement(s) du comptable pointé(s).'
                          : '') +
                        (aDater.length
                          ? '\n' +
                            trf('{0} dépense(s) datée(s) : payée(s) par la banque.', aDater.length)
                          : '') +
                        (aVerifier.length
                          ? '\n⚠ ' +
                            trf(
                              '{0} date(s) de paiement à vérifier : la banque dit un autre jour.',
                              aVerifier.length,
                            ) +
                            '\n' +
                            aVerifier
                              .map((l) => '· ' + (l.fournisseur || l.libelle) + ' — ' + l.jour)
                              .join('\n')
                          : '') +
                        (aVoir ? '\n⚠ ' + trf('{0} mouvement(s) à vérifier.', aVoir) : '') +
                        (controle.ecart === undefined || controle.aVerifier
                          ? ''
                          : '\n' +
                            (Math.abs(controle.ecart) < 0.005
                              ? trf(
                                  '✓ Soldes vérifiés : {0} + entrées − sorties = {1}',
                                  fmt(controle.initial),
                                  fmt(controle.final),
                                )
                              : trf(
                                  '⚠ Écart de {0} entre les soldes du relevé et ses mouvements : un mouvement manque peut-être.',
                                  fmt(controle.ecart),
                                )));
                      window.alert(lu ? lu + '\n' + bilan : bilan);
                    } catch (_) {}
                  };
                  if (f.type === 'application/pdf' || /\.pdf$/i.test(f.name || '')) {
                    lisRelevePdf(f)
                      .catch(() => null)
                      .then((lu) => {
                        if (!lu || !lu.avecTexte) {
                          // Un PDF scanné n'est qu'une image : rien à lire.
                          alerte(
                            tr(
                              'Ce PDF n’a pas de texte lisible (relevé scanné ou photo). Dans ton e-banking, exporte le relevé au format camt.053 (XML) ou télécharge-le en PDF, puis choisis ce fichier.',
                            ),
                          );
                          return;
                        }
                        const tx = lu.transactions;
                        if (!tx.length) {
                          alerte(
                            tr(
                              'Aucun mouvement trouvé dans ce PDF. Exporte plutôt le relevé au format camt.053 (XML) depuis ton e-banking.',
                            ),
                          );
                          return;
                        }
                        // Lu dans un PDF, une ligne peut avoir échappé : le
                        // patron compare les nombres avec son relevé.
                        importe(
                          tx,
                          trf(
                            'Lu dans le PDF : {0} entrée(s) et {1} sortie(s). Compare avec ton relevé.',
                            tx.filter((t) => t.sens === 'CRDT').length,
                            tx.filter((t) => t.sens === 'DBIT').length,
                          ),
                          { soldeInitial: lu.soldeInitial, soldeFinal: lu.soldeFinal },
                          lu.banque || '',
                        );
                      });
                  } else {
                    const rd = new FileReader();
                    rd.onload = (ev) => {
                      const releve = lisCamt053(ev.target.result);
                      const tx = releve?.transactions;
                      if (!tx || !tx.length) {
                        alerte(
                          tr(
                            'Fichier non reconnu. Exporte un relevé camt.053 (format XML) depuis ton e-banking.',
                          ),
                        );
                        return;
                      }
                      importe(
                        tx,
                        '',
                        { soldeInitial: releve.soldeInitial, soldeFinal: releve.soldeFinal },
                        banqueDuCamt(ev.target.result),
                      );
                    };
                    rd.readAsText(f);
                  }
                }
                e.target.value = '';
              }}
            />
          </label>
          {(() => {
            const tx = (soc && soc.releveBancaire) || [];
            // Les totaux de l'exercice affiché : le relevé gardé couvre toutes
            // les années, et un doublon possible ne compte pas. Les soldes du
            // relevé, quand il les dit, contrôlent qu'aucun mouvement ne manque.
            const totaux = totauxDuReleve(tx, anneeC);
            const { entrees, sorties } = totaux;
            // L'acompte d'une offre payé par virement : le serveur établit la
            // facture d'acompte (ou rend celle qui existe), le paiement s'y
            // enregistre comme sur toute facture, puis l'écran relit factures
            // et offres. Le paiement part directement au serveur : glissé dans
            // la relecture, il passait pour l'état du serveur et ne partait pas.
            const encaisseAcompte = async (offre, montant, date) => {
              try {
                // Une offre encore en attente : l'acompte versé vaut accord du
                // client, comme le « oui » que le patron enregistre à l'écran.
                const enAttente = offre.statut === 'En attente';
                if (enAttente) {
                  const cl = (clients || []).find((c) => c.id === offre.clientId);
                  await devisApi.accepte(offre.id, { signataire: cl?.nom || '' });
                }
                const dto = await devisApi.factureAcompte(offre.id);
                const payee = factureApresPaiement(dtoVersFacture(dto), montant, date);
                await facturesApi.metAJour(dto.id, factureVersDto(payee));
                await rechargeFactures();
                if (rechargeDevis) await rechargeDevis();
                if (enAttente && rechargeChantiers) await rechargeChantiers();
                return dto.id;
              } catch (e) {
                try {
                  window.alert(e?.message || tr('L’acompte n’a pas pu être enregistré.'));
                } catch (_) {}
                return null;
              }
            };
            const peutAcompte =
              !!setFactures && !!rechargeFactures && peutEncaisser() && (devis || []).length > 0;
            return (
              <div>
                {tx.length > 0 && (
                  <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 8 }}>
                    <button
                      type="button"
                      onClick={() => {
                        let oui = false;
                        try {
                          oui = window.confirm(
                            tr(
                              'Supprimer le relevé importé ? Les paiements et dépenses déjà enregistrés restent.',
                            ),
                          );
                        } catch (_) {}
                        if (oui) setSoc((p) => ({ ...p, releveBancaire: null }));
                      }}
                      style={{
                        border: '1px solid ' + C.border,
                        background: '#fff',
                        color: C.red,
                        borderRadius: 8,
                        padding: '6px 10px',
                        fontSize: 10,
                        fontWeight: 800,
                        cursor: 'pointer',
                      }}
                    >
                      {tr('🗑 Supprimer le relevé')}
                    </button>
                  </div>
                )}
                {tx.length > 0 && (
                  <div
                    style={{
                      display: 'grid',
                      gridTemplateColumns: '1fr 1fr',
                      gap: 8,
                      marginBottom: 11,
                    }}
                  >
                    <StatBox
                      label="Total entrées"
                      value={DEVISE + ' ' + fmt(entrees)}
                      color={C.green}
                      icon="⬇"
                    />
                    <StatBox
                      label="Total sorties"
                      value={DEVISE + ' ' + fmt(sorties)}
                      color={C.red}
                      icon="⬆"
                    />
                    <div
                      data-testid="controle-soldes"
                      style={{
                        gridColumn: '1 / -1',
                        fontSize: 9.5,
                        lineHeight: 1.4,
                        color:
                          totaux.ecart !== undefined && Math.abs(totaux.ecart) >= 0.005
                            ? C.amber
                            : C.muted,
                      }}
                    >
                      {trf('Exercice {0}', anneeC)}
                      {totaux.ecart !== undefined &&
                        ' · ' +
                          (Math.abs(totaux.ecart) < 0.005
                            ? trf(
                                '✓ Soldes vérifiés : {0} + entrées − sorties = {1}',
                                fmt(totaux.initial),
                                fmt(totaux.final),
                              )
                            : trf(
                                '⚠ Écart de {0} entre les soldes du relevé et ses mouvements : un mouvement manque peut-être.',
                                fmt(totaux.ecart),
                              ))}
                      {totaux.aVerifier > 0 &&
                        ' · ⚠ ' + trf('{0} mouvement(s) à vérifier.', totaux.aVerifier)}
                    </div>
                  </div>
                )}
                {tx.length === 0 ? (
                  <div style={{ textAlign: 'center', padding: 24, color: C.muted, fontSize: 11 }}>
                    {tr('Aucun relevé importé. Importe ton relevé (PDF ou camt.053) ci-dessus.')}
                  </div>
                ) : (
                  <MouvementsReleve
                    mouvements={tx}
                    comptable={cpt}
                    factures={facturesToutes}
                    clients={clients}
                    devis={devis}
                    onPaiement={
                      setFactures && peutEncaisser()
                        ? (id, montant, date) =>
                            setFactures((p) =>
                              p.map((x) =>
                                x.id === id ? factureApresPaiement(x, montant, date, p) : x,
                              ),
                            )
                        : undefined
                    }
                    onAcompte={peutAcompte ? encaisseAcompte : undefined}
                    onNote={(cle, note) =>
                      setSoc((p) => ({
                        ...p,
                        releveBancaire: noteMouvement(p?.releveBancaire, cle, note),
                      }))
                    }
                    onOuvreOffre={onNav ? (id) => onNav('devis', { devisId: id }) : undefined}
                    onRetire={(cle) =>
                      setSoc((p) => ({
                        ...p,
                        releveBancaire: retireMouvement(p?.releveBancaire, cle),
                      }))
                    }
                    chantiers={chantiers}
                    employes={employes}
                    frais={fraisTous}
                    achats={achatsJoints}
                    onPointeComptable={(annee, periode) => pointeComptable([{ annee, periode }])}
                    onAjouteDepense={
                      setFrais
                        ? (d) => setFrais((p) => [{ ...d, id: idProvisoire() }, ...(p || [])])
                        : undefined
                    }
                  />
                )}
              </div>
            );
          })()}
          <div
            style={{
              fontSize: 8.5,
              color: C.muted,
              marginTop: 10,
              textAlign: 'center',
              lineHeight: 1.5,
            }}
          >
            {tr(
              '💡 Chaque sortie est reliée à ce qu’elle paie : le comptable est pointé tout seul, une facture fournisseur déjà saisie est reconnue, et une autre sortie s’ajoute aux dépenses d’un geste.',
            )}
          </div>
        </div>
      )}
      {tab === 'synthese' && (
        <div>
          <AcomptesAnnee
            factures={facturesToutes}
            setFactures={setFactures}
            clients={clients}
            devis={devis}
            annee={anneeC}
          />
          <AcomptesAnterieurs
            factures={facturesToutes}
            paiements={paiements}
            regle={regleAc}
            onRegle={(an, regle) =>
              setReglageJson(CLE_REGLE_ACOMPTES, avecRegleDeLAnnee(reglageAc, an, regle))
            }
            clients={clients}
            annee={anneeC}
          />
          <div
            style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8, marginBottom: 11 }}
          >
            <StatBox
              label="Total facturé HT"
              // Factures et caisse, comme « Facturé sans TVA » de l'accueil :
              // le même mot donnait deux chiffres.
              value={DEVISE + ' ' + fmt(totalFacture + ventesHT)}
              sous={
                <>
                  {DEVISE}{' '}
                  {fmt(
                    totalFactureTtc +
                      ventesExercice.reduce(
                        (t, v) => t + htVente(v) * (1 + (v.tx != null ? +v.tx : tauxMagasin) / 100),
                        0,
                      ),
                  )}{' '}
                  {tr('TTC')}
                </>
              }
              color={C.green}
              icon="📈"
            />
            <StatBox
              label="CA encaissé HT"
              value={DEVISE + ' ' + fmt(caEncaisse)}
              color={C.teal}
              icon="💰"
            />
            <StatBox
              label="Impayés TTC"
              value={DEVISE + ' ' + fmt(impayes)}
              color={C.amber}
              icon="⏳"
            />
            <StatBox
              label="Salaires + charges sociales"
              value={DEVISE + ' ' + fmt(masseSal)}
              color={C.navy}
              icon="👷"
            />
            {remboursements > 0 && (
              <StatBox
                label="Remboursements"
                value={DEVISE + ' ' + fmt(remboursements)}
                color={C.purple}
                icon="↩"
              />
            )}
          </div>
          <Card style={{ marginBottom: 11 }}>
            <Bar
              icon="📊"
              title={"Chiffre d'affaires " + anneeC}
              color={C.teal}
              sub="Par mois, TTC"
            />
            <div style={{ padding: '14px 13px 10px' }}>
              <div style={{ display: 'flex', alignItems: 'flex-end', gap: 3, height: 108 }}>
                {caMois.map((v, i) => (
                  <div
                    key={i}
                    style={{
                      flex: 1,
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'flex-end',
                    }}
                  >
                    <div style={{ fontSize: 6, color: C.muted, marginBottom: 2, height: 8 }}>
                      {/* 421.– en janvier se lisait « 0k » : sous mille, le montant. */}
                      {v > 0
                        ? v >= 1000
                          ? (v / 1000).toFixed(v >= 10000 ? 0 : 1) + 'k'
                          : String(Math.round(v))
                        : ''}
                    </div>
                    <div
                      style={{
                        width: '76%',
                        height: Math.max(2, Math.round((v / caMax) * 82)) + 'px',
                        background: C.teal,
                        borderRadius: '3px 3px 0 0',
                      }}
                    />
                    <div style={{ fontSize: 6, color: C.muted, marginTop: 3 }}>{moisLbl[i]}</div>
                  </div>
                ))}
              </div>
            </div>
          </Card>
          <Card>
            <Bar icon="🧮" title="Compte de résultat" color={C.green} sub={'Exercice ' + anneeC} />
            <div style={{ padding: 13 }}>
              <div
                style={{
                  fontSize: 8.5,
                  fontWeight: 800,
                  color: C.muted,
                  textTransform: 'uppercase',
                  letterSpacing: 0.4,
                  marginBottom: 4,
                }}
              >
                Produits
              </div>
              <FR
                label="Chiffre d'affaires (HT)"
                value={DEVISE + ' ' + fmt(totalFacture)}
                color={C.green}
              />
              {ventesHT > 0 && (
                <FR label="Ventes caisse" value={DEVISE + ' ' + fmt(ventesHT)} color={C.green} />
              )}
              <FR label="Total produits" value={DEVISE + ' ' + fmt(produitsTot)} bold />
              <div
                style={{
                  fontSize: 8.5,
                  fontWeight: 800,
                  color: C.muted,
                  textTransform: 'uppercase',
                  letterSpacing: 0.4,
                  margin: '11px 0 4px',
                }}
              >
                Charges
              </div>
              <FR
                label={magC ? 'Achats de marchandise (HT)' : 'Achats des chantiers (HT)'}
                value={DEVISE + ' ' + fmt(achatsChantiersHt)}
                color={C.purple}
              />
              {magC && variationStock !== null && (
                <FR
                  label={tr('Marchandise restée au dépôt (stock)')}
                  value={
                    (variationStock >= 0 ? '− ' : '+ ') +
                    DEVISE +
                    ' ' +
                    fmt(Math.abs(variationStock))
                  }
                  color={C.green}
                />
              )}
              <FR
                label="Frais & charges d'exploitation (HT)"
                value={DEVISE + ' ' + fmt(fraisHt)}
                color={C.red}
              />
              {vehAnnee.charge > 0 && (
                <FR
                  label="🚗 Véhicules (leasing + amortissement)"
                  value={DEVISE + ' ' + fmt(vehAnnee.charge)}
                  color={C.red}
                />
              )}
              <FR
                label="Salaires + charges sociales"
                value={DEVISE + ' ' + fmt(masseSal)}
                color={C.navy}
              />
              {cptAn > 0 && (
                <FR
                  label="Comptable / fiduciaire"
                  value={DEVISE + ' ' + fmt(cptAn)}
                  color={C.teal}
                />
              )}
              <FR label="Total charges" value={DEVISE + ' ' + fmt(chargesTot)} bold />
              <div style={{ marginTop: 6 }} />
              <FR
                label={resultat >= 0 ? 'BÉNÉFICE' : 'PERTE'}
                value={DEVISE + ' ' + fmt(Math.abs(resultat))}
                color={resultat >= 0 ? C.green : C.red}
                bold
                last
              />
              <div style={{ fontSize: 8, color: C.muted, marginTop: 7, lineHeight: 1.4 }}>
                Estimation indicative — à valider avec ta fiduciaire. Détail des écritures dans
                l'onglet Journal.
              </div>
            </div>
          </Card>
          <Card style={{ marginTop: 11 }}>
            <Bar
              icon="🏆"
              title="Top clients & articles"
              color={C.amber}
              sub={tr("Tes meilleures sources de chiffre d'affaires") + ' · ' + tr('HT')}
            />
            <div style={{ padding: 13 }}>
              <div
                style={{
                  fontSize: 8.5,
                  fontWeight: 800,
                  color: C.muted,
                  textTransform: 'uppercase',
                  letterSpacing: 0.4,
                  marginBottom: 5,
                }}
              >
                Top clients
              </div>
              {topClients.length === 0 ? (
                <div style={{ fontSize: 9, color: C.muted, marginBottom: 8 }}>—</div>
              ) : (
                topClients.map((c, i) => (
                  <div
                    key={i}
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      padding: '4px 0',
                      fontSize: 10,
                      borderBottom: i < topClients.length - 1 ? '1px dotted ' + C.border : 'none',
                    }}
                  >
                    <span
                      style={{
                        flex: 1,
                        marginRight: 8,
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                      }}
                    >
                      {i + 1}. {c.nom}
                    </span>
                    <b style={{ whiteSpace: 'nowrap', color: C.teal }}>
                      {DEVISE} {fmt(c.v)}
                    </b>
                  </div>
                ))
              )}
              <div
                style={{
                  fontSize: 8.5,
                  fontWeight: 800,
                  color: C.muted,
                  textTransform: 'uppercase',
                  letterSpacing: 0.4,
                  margin: '11px 0 5px',
                }}
              >
                Top articles
              </div>
              {topProduits.length === 0 ? (
                <div style={{ fontSize: 9, color: C.muted }}>—</div>
              ) : (
                topProduits.map((p, i) => (
                  <div
                    key={i}
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      padding: '4px 0',
                      fontSize: 10,
                      borderBottom: i < topProduits.length - 1 ? '1px dotted ' + C.border : 'none',
                    }}
                  >
                    <span
                      style={{
                        flex: 1,
                        marginRight: 8,
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                      }}
                    >
                      {i + 1}. {p.nom}
                    </span>
                    <b style={{ whiteSpace: 'nowrap', color: C.purple }}>
                      {DEVISE} {fmt(p.v)}
                    </b>
                  </div>
                ))
              )}
            </div>
          </Card>
          <Card style={{ marginTop: 11 }}>
            <Bar
              icon="🧮"
              title="Comptable / Fiduciaire"
              color={C.navy}
              sub="Ce que tu paies à ton comptable"
            />
            <div style={{ padding: 13 }}>
              <Inp
                label="Nom du comptable / fiduciaire"
                value={cptForm.nom}
                onChange={(e) => setCptForm((p) => ({ ...p, nom: e.target.value }))}
                placeholder="Ex. Fiduciaire Genève SA"
              />
              <Inp
                label="Adresse"
                value={cptForm.adresse || ''}
                onChange={(e) => setCptForm((p) => ({ ...p, adresse: e.target.value }))}
                placeholder="Rue, NPA, ville"
              />
              <div style={{ display: 'flex', gap: 8 }}>
                <div style={{ flex: 1 }}>
                  <Inp
                    label="Téléphone"
                    type="tel"
                    value={cptForm.tel || ''}
                    onChange={(e) => setCptForm((p) => ({ ...p, tel: e.target.value }))}
                    placeholder="+41 ..."
                  />
                </div>
                <div style={{ flex: 1 }}>
                  <Inp
                    label="Email"
                    type="email"
                    value={cptForm.email || ''}
                    onChange={(e) => setCptForm((p) => ({ ...p, email: e.target.value }))}
                    placeholder="contact@..."
                  />
                </div>
              </div>
              {/* Montant et fréquence sur leur propre ligne : glissés dans
                  celle du téléphone, ils écrasaient la case de l'e-mail. */}
              <div style={{ display: 'flex', gap: 8 }}>
                <div style={{ flex: 1 }}>
                  <Inp
                    label={'Montant ' + DEVISE}
                    type="text"
                    inputMode="decimal"
                    value={cptForm.montant}
                    onChange={(e) =>
                      setCptForm((p) => ({ ...p, montant: e.target.value.replace(',', '.') }))
                    }
                    placeholder="0.00"
                  />
                </div>
                <div style={{ flex: 1 }}>
                  <Inp label="Fréquence">
                    <select
                      value={cptForm.freq}
                      onChange={(e) => setCptForm((p) => ({ ...p, freq: e.target.value }))}
                      style={{
                        width: '100%',
                        border: '1px solid ' + C.border,
                        borderRadius: 9,
                        padding: '10px',
                        fontSize: 11,
                      }}
                    >
                      <option value="mensuel">Par mois</option>
                      <option value="trimestriel">Par trimestre</option>
                      <option value="semestriel">Par semestre</option>
                      <option value="annuel">Par an</option>
                    </select>
                  </Inp>
                </div>
              </div>
              <div style={{ fontSize: 9, color: C.grey, lineHeight: 1.45, margin: '2px 0 8px' }}>
                {tr(
                  'Payé par bulletin de versement ? Paie-le dans ton e-banking, puis importe le relevé du mois (onglet Banque) : SwissTech reconnaît le paiement et coche la période tout seul.',
                )}
                <br />
                {tr(
                  'Ta comptable travaille seulement pour toi, avec un salaire fixe ? Ajoute-la dans Équipe avec son salaire mensuel et laisse ce montant à 0 : elle est alors comptée dans les salaires et les charges sociales, une seule fois.',
                )}
              </div>
              {cptDraftAn > 0 && (
                <div
                  style={{
                    background: C.navyXL,
                    borderRadius: 9,
                    padding: '9px 11px',
                    fontSize: 10,
                    color: C.grey,
                    marginBottom: 9,
                  }}
                >
                  Coût annualisé :{' '}
                  <b style={{ color: C.ink }}>
                    {DEVISE} {fmt(cptDraftAn)}
                  </b>
                </div>
              )}
              <Btn
                label="✓ Enregistrer le comptable"
                color={C.navy}
                full
                onClick={() => {
                  setReglageJson(CLE_COMPTABLE, {
                    nom: (cptForm.nom || '').trim(),
                    adresse: (cptForm.adresse || '').trim(),
                    tel: (cptForm.tel || '').trim(),
                    email: (cptForm.email || '').trim(),
                    montant: +('' + cptForm.montant).replace(',', '.') || 0,
                    freq: cptForm.freq,
                    // Les reglements deja pointes ne doivent pas disparaitre
                    // parce qu'on corrige un numero de telephone.
                    paye: comptable?.paye || {},
                  });
                }}
              />
              {cpt && cpt.nom && (
                <div style={{ fontSize: 9, color: C.green, fontWeight: 700, marginTop: 8 }}>
                  ✓ Enregistré : {cpt.nom} — {DEVISE} {fmt(+cpt.montant || 0)}{' '}
                  {FREQ_LBL[cpt.freq] || ''}
                </div>
              )}

              {cpt && cpt.nom && (+cpt.montant || 0) > 0 && (
                <div style={{ marginTop: 13, borderTop: '1px solid ' + C.border, paddingTop: 12 }}>
                  <div style={{ fontSize: 10.5, fontWeight: 800, color: C.navy }}>
                    Suivi des paiements · {anneeC}
                  </div>
                  <div style={{ fontSize: 8.5, color: C.muted, marginBottom: 10 }}>
                    Payé :{' '}
                    <b style={{ color: C.green }}>
                      {DEVISE} {fmt(soldeCpt.paye)}
                    </b>{' '}
                    / {DEVISE} {fmt(soldeCpt.du)} · reste{' '}
                    <b style={{ color: soldeCpt.reste > 0 ? C.amber : C.green }}>
                      {DEVISE} {fmt(soldeCpt.reste)}
                    </b>
                  </div>
                  {periodesComptable(cpt.freq).map(([k, lab]) => {
                    const cle = anneeC + '-' + k;
                    const regle = (cpt.paye || {})[cle];
                    return (
                      <div
                        key={k}
                        onClick={() => basculePaiement(k)}
                        style={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                          padding: '8px 10px',
                          marginBottom: 5,
                          borderRadius: 8,
                          cursor: 'pointer',
                          background: regle ? C.greenL : C.navyXL,
                          border: '1px solid ' + (regle ? C.green : C.border),
                        }}
                      >
                        <div style={{ flex: 1, marginRight: 8 }}>
                          <div style={{ fontSize: 10.5, fontWeight: 700, color: C.ink }}>
                            {regle ? '✓ ' : ''}
                            {lab}
                          </div>
                          <div style={{ fontSize: 8, color: regle ? C.green : C.muted }}>
                            {regle ? 'réglé' : 'à régler'}
                          </div>
                        </div>
                        <div
                          style={{
                            fontSize: 11,
                            fontWeight: 800,
                            color: regle ? C.green : C.grey,
                            whiteSpace: 'nowrap',
                          }}
                        >
                          {DEVISE} {fmt(+cpt.montant || 0)}
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          </Card>
          {(() => {
            const rbs = factures.filter((f) => f.remboursement);
            if (!rbs.length) return null;
            return (
              <Card style={{ marginTop: 11 }}>
                <Bar
                  icon="↩"
                  title="Remboursements émis"
                  color={C.purple}
                  sub="Trop-perçus rendus aux clients"
                />
                <div style={{ padding: 13 }}>
                  {rbs.map((f) => {
                    const cl = clients.find((c) => c.id === f.clientId);
                    return (
                      <div
                        key={f.id}
                        style={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'flex-start',
                          padding: '8px 0',
                          borderBottom: '1px solid ' + C.border,
                        }}
                      >
                        <div style={{ flex: 1, marginRight: 10 }}>
                          <div style={{ fontSize: 10, fontWeight: 700 }}>
                            {cl?.nom || 'Client'} · {f.num || f.id}
                          </div>
                          <div style={{ fontSize: 8.5, color: C.muted }}>
                            {f.remboursement.motif} · {f.remboursement.date}
                          </div>
                        </div>
                        <div style={{ fontSize: 12, fontWeight: 900, color: C.purple }}>
                          − {DEVISE} {fmt(f.remboursement.montant)}
                        </div>
                      </div>
                    );
                  })}
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      marginTop: 9,
                      fontSize: 11,
                      fontWeight: 800,
                    }}
                  >
                    <span>Total remboursé</span>
                    <span style={{ color: C.purple }}>
                      {DEVISE} {fmt(remboursements)}
                    </span>
                  </div>
                </div>
              </Card>
            );
          })()}
        </div>
      )}
      {tab === 'echeancier' && (
        <div>
          <StatBox
            label="Total à encaisser"
            value={DEVISE + ' ' + fmt(totalAVenir)}
            color={C.amber}
          />
          <div style={{ margin: '11px 0' }} />
          {echeancier.length === 0 && (
            <Card>
              <div style={{ padding: 20, textAlign: 'center', color: C.muted, fontSize: 11 }}>
                Aucune facture en attente
              </div>
            </Card>
          )}
          {echeancier.map((f) => {
            const cl = clients.find((c) => c.id === f.clientId);
            return (
              <Card key={f.id} style={{ marginBottom: 8, borderLeft: '4px solid ' + C.amber }}>
                <div
                  style={{
                    padding: '11px 13px',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                  }}
                >
                  <div>
                    <div style={{ fontSize: 11, fontWeight: 800 }}>{f.num || f.id}</div>
                    <div style={{ fontSize: 9, color: C.grey }}>
                      {cl?.nom} · {f.date}
                    </div>
                  </div>
                  <div style={{ fontSize: 13, fontWeight: 900, color: C.amber }}>
                    {DEVISE} {fmt(soldeApresAvoirs(f, toutesLesFactures))}
                  </div>
                </div>
              </Card>
            );
          })}
        </div>
      )}
      {tab === 'journal' &&
        (() => {
          const ent = [];
          factures
            .filter((f) => f.type !== 'avoir' && compteDansLeCa(f))
            .forEach((f) => {
              const cl = clients.find((c) => c.id === f.clientId);
              ent.push({
                date: f.date || '',
                compte: '3200',
                lib: 'Facture ' + (f.num || f.id) + (cl ? ' — ' + cl.nom : ''),
                sens: 'Produit',
                montant: htOf(f),
                tva: totauxDocument(f.lignes, f.tvaPct, f.remisePct).tva,
              });
            });
          factures
            .filter((f) => f.type === 'avoir' && compteDansLeCa(f))
            .forEach((f) => {
              const cl = clients.find((c) => c.id === f.clientId);
              ent.push({
                date: f.date || '',
                compte: '3200',
                lib: 'Avoir ' + (f.num || f.id) + (cl ? ' — ' + cl.nom : ''),
                sens: 'Produit',
                montant: -htOf(f),
                tva: -totauxDocument(f.lignes, f.tvaPct, f.remisePct).tva,
              });
            });
          ventesExercice.forEach((v) => {
            ent.push({
              date: v.date || '',
              compte: '3000',
              // Un avoir est une vente negative : il se lit comme tel dans le
              // journal, et se retranche du produit.
              lib: (estAvoir(v) ? 'Avoir caisse ' : 'Vente caisse ') + (v.ticket || v.id || ''),
              sens: 'Produit',
              // Le compte 3000 recoit le produit hors taxe : la TVA encaissee
              // n'est pas un produit, elle est due a l'AFC.
              montant: htVente(v),
              tva: (htVente(v) * (v.tx != null ? +v.tx : tauxMagasin)) / 100,
            });
          });
          (frais || []).forEach((x) => {
            const c = FRAIS_CAT[x.type] || {};
            ent.push({
              date: x.date || '',
              compte: c.compte || '6000',
              lib: (c.lib || x.type || 'Frais') + (x.libelle ? ' — ' + x.libelle : ''),
              sens: 'Charge',
              // Hors taxe, comme les produits : la TVA payée se récupère, elle
              // a sa colonne. Le journal mêlait produits HT et charges TTC.
              montant: (+x.montant || 0) - tvaDeLaDepense(x, FRAIS_CAT, soc),
              tva: tvaDeLaDepense(x, FRAIS_CAT, soc),
            });
          });
          ent.sort((a, b) => (b.date || '').localeCompare(a.date || ''));
          const annees = [
            ...new Set(
              ent
                .map((e) => {
                  const m = String(e.date).match(/(\d{4})/);
                  return m ? m[1] : null;
                })
                .filter(Boolean),
            ),
          ]
            .sort()
            .reverse();
          const entF = jAnnee ? ent.filter((e) => String(e.date).indexOf(jAnnee) >= 0) : ent;
          const prod = entF.filter((e) => e.sens === 'Produit').reduce((s, e) => s + e.montant, 0);
          const chg = entF.filter((e) => e.sens === 'Charge').reduce((s, e) => s + e.montant, 0);
          const expJ = () => {
            try {
              const rows = [['Date', 'Compte', 'Libelle', 'Sens', 'Montant HT CHF', 'TVA CHF']];
              entF.forEach((e) =>
                rows.push([
                  e.date,
                  e.compte,
                  e.lib,
                  e.sens,
                  e.montant.toFixed(2),
                  (+e.tva || 0).toFixed(2),
                ]),
              );
              const csv = rows
                .map((r) => r.map((v) => '"' + String(v).replace(/"/g, '""') + '"').join(';'))
                .join(String.fromCharCode(10));
              const blob = new Blob([String.fromCharCode(0xfeff) + csv], {
                type: 'text/csv;charset=utf-8',
              });
              const url = URL.createObjectURL(blob);
              const a = document.createElement('a');
              a.href = url;
              a.download = 'journal-swisstech.csv';
              a.click();
              URL.revokeObjectURL(url);
            } catch (e) {}
          };
          return (
            <div>
              <div
                style={{
                  display: 'grid',
                  gridTemplateColumns: '1fr 1fr',
                  gap: 8,
                  marginBottom: 11,
                }}
              >
                <StatBox
                  label="Total produits"
                  value={DEVISE + ' ' + fmt(prod)}
                  color={C.green}
                  icon="📈"
                />
                <StatBox
                  label="Total charges"
                  value={DEVISE + ' ' + fmt(chg)}
                  color={C.red}
                  icon="📉"
                />
              </div>
              {annees.length > 0 && (
                <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', marginBottom: 10 }}>
                  <span
                    onClick={() => setJAnnee('')}
                    style={{
                      fontSize: 9.5,
                      fontWeight: 700,
                      padding: '6px 11px',
                      borderRadius: 99,
                      cursor: 'pointer',
                      background: jAnnee === '' ? C.navy : C.white,
                      color: jAnnee === '' ? '#fff' : C.grey,
                      border: '1px solid ' + C.border,
                    }}
                  >
                    Toutes
                  </span>
                  {annees.map((a) => (
                    <span
                      key={a}
                      onClick={() => setJAnnee(a)}
                      style={{
                        fontSize: 9.5,
                        fontWeight: 700,
                        padding: '6px 11px',
                        borderRadius: 99,
                        cursor: 'pointer',
                        background: jAnnee === a ? C.navy : C.white,
                        color: jAnnee === a ? '#fff' : C.grey,
                        border: '1px solid ' + C.border,
                      }}
                    >
                      {a}
                    </span>
                  ))}
                </div>
              )}
              <div style={{ marginBottom: 10 }}>
                <Btn
                  label="⬇ Exporter le journal (CSV pour la fiduciaire)"
                  color={C.navy}
                  full
                  onClick={expJ}
                />
              </div>
              <Card>
                <Bar
                  icon="📒"
                  title="Grand livre / Journal"
                  color={C.navy}
                  sub="Toutes les écritures (factures, ventes, frais)"
                />
                <div style={{ padding: 0 }}>
                  {entF.length === 0 ? (
                    <div style={{ padding: 18, textAlign: 'center', color: C.muted, fontSize: 10 }}>
                      Aucune écriture pour cette période
                    </div>
                  ) : (
                    entF.map((e, i) => (
                      <div
                        key={i}
                        style={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                          padding: '9px 13px',
                          borderBottom: '1px solid ' + C.border,
                        }}
                      >
                        <div style={{ flex: 1, marginRight: 10 }}>
                          <div style={{ fontSize: 10, fontWeight: 700 }}>{e.lib}</div>
                          <div style={{ fontSize: 8, color: C.muted }}>
                            {e.date || '—'} · compte {e.compte} · {e.sens}
                          </div>
                        </div>
                        <div
                          style={{
                            fontSize: 11.5,
                            fontWeight: 800,
                            color: e.sens === 'Produit' ? C.green : C.red,
                            whiteSpace: 'nowrap',
                          }}
                        >
                          {e.sens === 'Produit' && e.montant >= 0 ? '+' : '−'} {DEVISE}{' '}
                          {fmt(Math.abs(e.montant))}
                        </div>
                      </div>
                    ))
                  )}
                </div>
              </Card>
              <div style={{ fontSize: 8, color: C.muted, marginTop: 8, lineHeight: 1.4 }}>
                Journal simplifié généré depuis tes factures, ventes et frais. Pour un bilan
                officiel, transmets cet export CSV à ta fiduciaire.
              </div>
            </div>
          );
        })()}
      {tab === 'tva' && (
        <PositionTva
          annee={anneeC}
          // Change dès qu'une pièce est ajoutée, modifiée ou payée : la
          // position est alors recalculée.
          version={[
            // La catégorie, la date et les lignes aussi : une dépense passée
            // de « Matériel » à « Loyer » gardait l'ancien chiffre.
            (facturesToutes || [])
              .map((f) =>
                [
                  f.id,
                  f.statut,
                  f.montantPaye || 0,
                  f.date,
                  f.dateCompta,
                  JSON.stringify(f.lignes),
                ].join(':'),
              )
              .join(),
            (fraisTous || [])
              .map((x) =>
                [x.id, x.montant, x.montantTva ?? '', x.type, x.date, x.dateCompta, x.tva].join(
                  ':',
                ),
              )
              .join(),
            (ventes || []).map((v) => [v.id, v.date, v.total, v.tx].join(':')).join(),
          ].join('|')}
          repli={
            <div>
              <Card style={{ marginBottom: 11 }}>
                <Bar
                  icon="🇨🇭"
                  title="Décompte TVA"
                  color={C.teal}
                  sub={`Taux ${tauxExercice.normal}% / ${tauxExercice.reduit}% / ${tauxExercice.hebergement}% sur ${anneeC}`}
                />
                <div style={{ padding: 13 }}>
                  <FR
                    label={
                      methodeTva === 'recues'
                        ? 'CA encaissé (factures payées)'
                        : 'CA facturé (factures émises)'
                    }
                    value={DEVISE + ' ' + fmt(decompte.base)}
                  />
                  {/*
                    L'assiette exoneree se declare a part : elle entre dans le
                    chiffre d'affaires sans porter de taxe, et le decompte la
                    taisait — un livre vendu a 0 % au comptoir n'apparaissait
                    nulle part.
                  */}
                  {decompte.exonere !== 0 && (
                    <FR
                      label="dont exonéré à 0 % (factures et ventes)"
                      value={DEVISE + ' ' + fmt(decompte.exonere)}
                      color={C.muted}
                    />
                  )}
                  <FR
                    label={
                      methodeTva === 'recues'
                        ? 'TVA collectée (sur factures payées)'
                        : 'TVA collectée (sur factures émises)'
                    }
                    value={DEVISE + ' ' + fmt(tvaCollectee)}
                    color={C.teal}
                  />
                  <FR
                    label="TVA déductible (sur frais & achats)"
                    value={'− ' + DEVISE + ' ' + fmt(tvaDeductible)}
                    color={C.green}
                  />
                  <FR
                    label={
                      tvaNette >= 0 ? "TVA nette à verser à l'AFC" : 'Crédit de TVA (en ta faveur)'
                    }
                    value={DEVISE + ' ' + fmt(Math.abs(tvaNette))}
                    color={tvaNette >= 0 ? C.red : C.green}
                    bold
                    last
                  />
                </div>
              </Card>
              <div
                style={{
                  background: C.tealL,
                  border: '1px solid ' + C.teal + '28',
                  borderRadius: 10,
                  padding: '10px 12px',
                  fontSize: 9,
                  color: C.grey,
                }}
              >
                Décompte indicatif. Taux normal de {tauxExercice.normal}%
                {tauxExercice.des ? ` dès le ${isoVersDate(tauxExercice.des)}` : ''} — à régler dans
                Réglages → Documents → TVA quand la loi change.
                {/* La méthode retenue change la base : elle reste dite, en une ligne. */}
                <div style={{ marginTop: 3, color: C.muted }}>
                  Méthode :{' '}
                  {methodeTva === 'recues'
                    ? 'contre-prestations reçues'
                    : 'contre-prestations convenues'}{' '}
                  (Réglages → Banque).
                </div>
              </div>
            </div>
          }
        />
      )}
      {tab === 'bilan' &&
        (() => {
          const stockVal = stockBilan;
          const banque = soldeBanque;
          const caisse = soldeCaisse;
          const immobilisations = vehAnnee.achats + vehAnnee.leasingAvance;
          const actifTot = banque + caisse + debiteurs + stockVal + immobilisations;
          const fondsPropres = actifTot - dettes - acomptesAvance;
          return (
            <div>
              <Card style={{ marginBottom: 11 }}>
                <Bar
                  icon="⚖️"
                  title={trf('Bilan au 31.12.{0}', anneeC)}
                  color={C.navy}
                  sub="Actif = Passif"
                />
                <div style={{ padding: 13 }}>
                  <div
                    style={{
                      fontSize: 8.5,
                      fontWeight: 800,
                      color: C.muted,
                      textTransform: 'uppercase',
                      letterSpacing: 0.4,
                      marginBottom: 4,
                    }}
                  >
                    Actif
                  </div>
                  <FR label="Banque" value={DEVISE + ' ' + fmt(banque)} />
                  <FR label="Caisse" value={DEVISE + ' ' + fmt(caisse)} />
                  <FR
                    label="Débiteurs (factures impayées)"
                    value={DEVISE + ' ' + fmt(debiteurs)}
                    color={C.amber}
                  />
                  <FR
                    label="Stock (au prix d'achat)"
                    value={stockFin === null ? tr('pas noté') : DEVISE + ' ' + fmt(stockVal)}
                    color={C.purple}
                  />
                  {/* Retrouvé tout seul depuis le journal du dépôt (achats et
                      sorties), ou repris de la clôture : rien à noter. */}
                  {stockDebutAn !== null && (
                    <div style={{ fontSize: 9, color: C.grey, margin: '-4px 0 6px' }}>
                      {trf('Stock au 1er janvier {0}', anneeC) +
                        ' : ' +
                        DEVISE +
                        ' ' +
                        fmt(stockDebutAn)}
                    </div>
                  )}
                  {vehAnnee.achats > 0 && (
                    <FR
                      label="🚗 Véhicules (valeur après amortissement)"
                      value={DEVISE + ' ' + fmt(vehAnnee.achats)}
                    />
                  )}
                  {vehAnnee.leasingAvance > 0 && (
                    <FR
                      label="Leasing payé d'avance"
                      value={DEVISE + ' ' + fmt(vehAnnee.leasingAvance)}
                    />
                  )}
                  <FR label="Total actif" value={DEVISE + ' ' + fmt(actifTot)} bold />
                  <div
                    style={{
                      fontSize: 8.5,
                      fontWeight: 800,
                      color: C.muted,
                      textTransform: 'uppercase',
                      letterSpacing: 0.4,
                      margin: '11px 0 4px',
                    }}
                  >
                    Passif
                  </div>
                  <FR
                    label="Dettes (créanciers, emprunts)"
                    value={DEVISE + ' ' + fmt(dettes)}
                    color={C.red}
                  />
                  {acomptesAvance > 0 && (
                    <FR
                      label="Acomptes reçus d'avance (travaux de l'année suivante)"
                      value={DEVISE + ' ' + fmt(acomptesAvance)}
                      color={C.amber}
                    />
                  )}
                  <FR
                    label="Fonds propres"
                    value={DEVISE + ' ' + fmt(fondsPropres)}
                    color={C.green}
                  />
                  <FR
                    label="Total passif"
                    value={DEVISE + ' ' + fmt(dettes + acomptesAvance + fondsPropres)}
                    bold
                    last
                  />
                </div>
              </Card>
              <Card>
                <Bar
                  icon="✏️"
                  title="Soldes à saisir"
                  color={C.teal}
                  sub={trf('Banque, caisse, dettes au 31.12.{0}', anneeC)}
                />
                <div style={{ padding: 13 }}>
                  <Inp
                    label={trf('Solde banque au 31.12.{0}', anneeC) + ' ' + DEVISE}
                    type="number"
                    value={soldesAn.banque ?? ''}
                    onChange={(e) =>
                      setReglageJson(
                        CLE_BILAN,
                        noteLeSolde(bilan, anneeC, 'banque', e.target.value),
                      )
                    }
                  />
                  <Inp
                    label={trf('Solde caisse au 31.12.{0}', anneeC) + ' ' + DEVISE}
                    type="number"
                    value={soldesAn.caisse ?? ''}
                    onChange={(e) =>
                      setReglageJson(
                        CLE_BILAN,
                        noteLeSolde(bilan, anneeC, 'caisse', e.target.value),
                      )
                    }
                  />
                  <Inp
                    label={trf('Dettes / emprunts au 31.12.{0}', anneeC) + ' ' + DEVISE}
                    type="number"
                    value={soldesAn.dettes ?? ''}
                    onChange={(e) =>
                      setReglageJson(
                        CLE_BILAN,
                        noteLeSolde(bilan, anneeC, 'dettes', e.target.value),
                      )
                    }
                  />
                  <div style={{ fontSize: 8, color: C.muted, marginTop: 6, lineHeight: 1.4 }}>
                    Bilan simplifié — débiteurs et stock calculés automatiquement. À valider avec ta
                    fiduciaire.
                  </div>
                </div>
              </Card>
              {/* La clôture vit dans l'onglet Bilan, comme sur la maquette. */}
              <Card style={{ marginTop: 11 }}>
                <Bar
                  icon="📄"
                  title={"Clôture de l'exercice " + anneeC}
                  color={C.green}
                  sub="Pour la déclaration d'impôts"
                />
                <div style={{ padding: 13 }}>
                  <Btn
                    label={'📄 Voir / imprimer le bilan ' + anneeC + ' (A4)'}
                    color={C.navy}
                    full
                    // Un exercice pas encore clôturé s'affiche sans date de
                    // clôture : l'aperçu disait « clôturé le » ce jour.
                    onClick={() =>
                      setClotureA4(clotures[anneeC] || { ...clotureDuJour(), dateCloture: null })
                    }
                  />
                  <div style={{ height: 8 }} />
                  <Btn
                    label={
                      clotures[anneeC]
                        ? '🔒 Mettre à jour la clôture ' + anneeC
                        : '🔒 Clôturer définitivement ' + anneeC
                    }
                    ghost
                    color={C.green}
                    full
                    onClick={figeLExercice}
                  />
                  {clotures[anneeC] && (
                    <div style={{ fontSize: 9, color: C.green, fontWeight: 700, marginTop: 8 }}>
                      ✓ Exercice {anneeC} clôturé le {clotures[anneeC].dateCloture}
                    </div>
                  )}
                  {Object.keys(clotures).length > 0 && (
                    <div style={{ marginTop: 13 }}>
                      <div
                        style={{
                          fontSize: 8.5,
                          fontWeight: 800,
                          color: C.muted,
                          textTransform: 'uppercase',
                          letterSpacing: 0.4,
                          marginBottom: 6,
                        }}
                      >
                        📚 Exercices clôturés
                      </div>
                      {Object.keys(clotures)
                        .sort((a, b) => b - a)
                        .map((an) => (
                          <div
                            key={an}
                            onClick={() => setClotureA4(clotures[an])}
                            style={{
                              display: 'flex',
                              justifyContent: 'space-between',
                              alignItems: 'center',
                              padding: '9px 11px',
                              marginBottom: 5,
                              borderRadius: 8,
                              background: C.navyXL,
                              cursor: 'pointer',
                            }}
                          >
                            <span style={{ fontSize: 11, fontWeight: 700 }}>Exercice {an}</span>
                            <span
                              style={{
                                fontSize: 11,
                                fontWeight: 800,
                                color: clotures[an].resultat >= 0 ? C.green : C.red,
                              }}
                            >
                              {DEVISE} {fmt(Math.round(clotures[an].resultat || 0))}
                            </span>
                          </div>
                        ))}
                    </div>
                  )}
                  <div style={{ fontSize: 8, color: C.muted, marginTop: 8, lineHeight: 1.4 }}>
                    La clôture fige les chiffres de l&apos;année pour ta déclaration d&apos;impôts.
                    Le document A4 est à remettre à ta fiduciaire ou au fisc.
                  </div>
                </div>
              </Card>
            </div>
          );
        })()}
      {tab === 'classeur' &&
        (() => {
          const htF = (f) =>
            (f.lignes || []).reduce(
              (a, l) => a + (+l.q || 0) * (+l.p || 0) * (1 - (l.rem || 0) / 100),
              0,
            );
          const facsCli = (factures || []).filter((f) => f.type !== 'avoir');
          const avoirs = (factures || []).filter((f) => f.type === 'avoir');
          // Les factures des fournisseurs et sous-traitants scannées sur les
          // offres, les factures ou les chantiers aussi, sans les ressaisir.
          // Les pièces de l'exercice affiché : une facture de chantier ou un
          // achat joint d'une autre année s'y ajoutait aussi.
          const types = depensesDuClasseur({
            frais: fraisDeLAnnee,
            chantiers,
            achatsJoints,
            factures: facturesToutes,
            devis,
            comptable: cpt,
            annee: anneeC,
          })
            .map(([k, arr]) => [
              k,
              arr.filter((it) => it.origine === 'frais' || anneeDe(it) === anneeC),
            ])
            .filter(([, arr]) => arr.length > 0);
          const releves = (soc && soc.releveBancaire) || [];
          const _di = {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            fontSize: 10,
            padding: '6px 0',
            borderTop: '1px solid #f6f8fa',
          };
          const _sum = {
            display: 'flex',
            alignItems: 'center',
            gap: 12,
            padding: '12px 14px',
            cursor: 'pointer',
            listStyle: 'none',
          };
          const _pic = (bg) => ({
            width: 40,
            height: 40,
            borderRadius: 12,
            background: bg,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: 20,
            flexShrink: 0,
          });
          const _grp = {
            fontSize: 9.5,
            fontWeight: 800,
            color: C.muted,
            textTransform: 'uppercase',
            letterSpacing: 0.4,
            margin: '16px 3px 8px',
          };
          // La cle vient du rang : ces lignes n'ont pas d'identite propre, et
          // React refusait de les distinguer — d'ou l'avertissement « unique
          // key prop » a chaque ouverture du classeur.
          const line = (l, r, col, cle) => (
            <div key={cle} style={_di}>
              <span>{l}</span>
              <b style={col ? { color: col } : {}}>{r}</b>
            </div>
          );
          // Une pièce du classeur : le document officiel s'ouvre pour être lu,
          // imprimé ou enregistré. Un brouillon, pas encore émis, s'ouvre dans
          // son module pour être terminé.
          const piece = (cle, texte, droite, col, chemin, params, module) => (
            <div key={cle} style={{ ..._di, flexWrap: 'wrap', gap: 6 }}>
              <span style={{ flex: '1 1 140px', minWidth: 0 }}>
                {texte}
                {droite ? (
                  <b style={{ color: col, marginLeft: 6, whiteSpace: 'nowrap' }}>{droite}</b>
                ) : null}
              </span>
              {chemin ? (
                <BoutonDocument
                  chemin={chemin}
                  params={params}
                  label="📄 Ouvrir / imprimer"
                  color={col}
                  sm
                />
              ) : (
                <Btn
                  label="✎ Terminer le brouillon"
                  color={C.grey}
                  sm
                  onClick={() => onNav && onNav(module)}
                />
              )}
            </div>
          );
          const emise = (x) => Number.isInteger(x?.id) && x.statut !== 'Brouillon';
          const card = (icon, name, items, color, renderItem, total, avant) => (
            <Card style={{ marginBottom: 6, overflow: 'hidden' }}>
              <details>
                <summary style={_sum}>
                  <div style={_pic((color || C.red) + '18')}>{icon}</div>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ fontSize: 12.5, fontWeight: 800 }}>{name}</div>
                    <div style={{ fontSize: 8.5, color: C.muted }}>
                      {items.length} document(s)
                      {total != null && (
                        <b style={{ color: C.ink, marginLeft: 6 }}>{DEVISE + ' ' + fmt(total)}</b>
                      )}
                    </div>
                  </div>
                  <div
                    style={{
                      textAlign: 'right',
                      fontSize: 10,
                      fontWeight: 800,
                      color: items.length ? color || C.red : C.muted,
                    }}
                  >
                    {items.length ? '▸ voir' : '—'}
                  </div>
                </summary>
                <div style={{ padding: '0 14px 10px' }}>
                  {avant}
                  {items.length === 0 ? (
                    <div style={{ fontSize: 9.5, color: C.muted, padding: 6 }}>
                      Aucun document pour l'instant.
                    </div>
                  ) : (
                    items.map(renderItem)
                  )}
                </div>
              </details>
            </Card>
          );
          return (
            <div>
              <Card style={{ marginBottom: 12 }}>
                <Bar
                  icon="📁"
                  title="Mes documents — le classeur"
                  color={C.navy}
                  sub="Tous tes documents rangés par type · clique une tuile pour ouvrir"
                />
                <div style={{ padding: '9px 14px', fontSize: 10, color: C.grey, lineHeight: 1.5 }}>
                  Pour <b>ajouter</b> : va dans le module concerné (Dépenses, Offres, Équipe…). Ici
                  tu <b>consultes</b> tout, rangé par type.
                  <br />
                  Chaque pièce émise s&apos;ouvre en document officiel, prêt à imprimer ou à
                  enregistrer.
                </div>
              </Card>

              <div style={_grp}>🏢 {tr('Mon entreprise')}</div>
              {/* Ce que la fiduciaire, une régie ou un contrôle fiscal
                  demandent : les attestations, puis tout le dossier de
                  l'année en un PDF. */}
              {/* Réservées au patron, à la comptable, et à qui en a reçu le
                  droit (Réglages → Accès). */}
              {soc?.id != null && voitLesAttestations(soc?.permAttestations) && (
                <AttestationsEntreprise
                  soc={soc}
                  pieces={attestations?.pieces || []}
                  onChange={attestations?.relit}
                  clients={clients}
                />
              )}
              <DossierAnnee
                soc={soc}
                magasin={magC}
                pieces={{
                  frais: fraisDeLAnnee,
                  chantiers,
                  achatsJoints,
                  factures: facturesToutes,
                  devis,
                  attestations: attestations?.pieces || [],
                }}
              />

              <div style={_grp}>🧾 Facturation & ventes</div>
              {/* Un dossier par chantier, un tableau par dossier : l'offre,
                  les acomptes, la facture finale et ce qui reste à encaisser. */}
              <FacturesClientsClasseur
                factures={facsCli}
                facturesToutes={facturesToutes}
                devis={devis}
                chantiers={chantiers}
                clients={clients}
                onNav={onNav}
              />
              {card('📝', 'Devis / offres', devis || [], C.teal, (d, i) => {
                const cl = (clients || []).find((c) => c.id === d.clientId);
                return piece(
                  i,
                  [d.date, cl?.nom].filter(Boolean).join(' · '),
                  d.num || '#' + (i + 1),
                  C.teal,
                  emise(d) ? `/devis/${d.id}/document` : null,
                  undefined,
                  'devis',
                );
              })}
              {card('↩️', 'Avoirs (notes de crédit)', avoirs, C.amber, (f, i) =>
                piece(
                  i,
                  // N° et client, montant TTC comme les factures du client :
                  // « 10CHF 500.00 » se lisait comme un seul nombre, hors TVA.
                  [
                    f.date,
                    f.num ? trf('n° {0}', f.num) : '',
                    (clients || []).find((c) => c.id === f.clientId)?.nom,
                  ]
                    .filter(Boolean)
                    .join(' · '),
                  '− ' + DEVISE + ' ' + fmt(ttcOf(f)),
                  C.amber,
                  emise(f) ? `/factures/${f.id}/document` : null,
                  undefined,
                  'factures',
                ),
              )}

              <ClasseurLettres
                card={card}
                piece={piece}
                styleGroupe={_grp}
                couleurs={{ courrier: C.navy, decharge: C.purple }}
              />
              <div style={_grp}>📦 Dépenses par type</div>
              {types.length === 0 ? (
                <Card>
                  <div style={{ padding: 14, textAlign: 'center', color: C.muted, fontSize: 11 }}>
                    Aucune dépense. Ajoute dans « Dépenses ».
                  </div>
                </Card>
              ) : (
                types.map(([k, arr], i) => {
                  const cat = FRAIS_CAT[k] || TYPES_DU_CLASSEUR[k] || {};
                  // Un fournisseur payé plusieurs fois (le loyer du dépôt chaque
                  // mois) : ses paiements sur une feuille A4 à imprimer.
                  const recurrents = groupesDePaiements(arr, releves);
                  // Deux choses différentes pour chaque type, quel qu'il soit
                  // (café, sous-traitance, matériel…) : consulter ses pièces
                  // à l'écran, ou les imprimer / envoyer en un PDF.
                  const tickets = (
                    <PanneauDuType
                      type={k}
                      annee={anneeC}
                      titre={tr(cat.lib || k)}
                      items={arr}
                      pieces={{
                        frais: fraisTous,
                        chantiers,
                        achatsJoints,
                        factures: facturesToutes,
                        devis,
                      }}
                      soc={soc}
                    />
                  );
                  const feuille = recurrents.length ? (
                    <div style={{ margin: '4px 0 8px' }}>
                      <BoutonDocument
                        chemin="/depenses/paiements-a4"
                        corps={() =>
                          demandePaiementsA4({
                            type: cat.lib || k,
                            compte: cat.compte,
                            periode: String(anneeC),
                            soc,
                            // Relus au clic : une date notée juste avant compte.
                            groupes: groupesDePaiements(arr, releves),
                          })
                        }
                        label={tr('📄 Feuille A4 des paiements')}
                        color={C.navy}
                        sm
                      />
                    </div>
                  ) : null;
                  return (
                    <div key={k}>
                      {card(
                        cat.icon || '📄',
                        cat.lib || k,
                        arr,
                        C.red,
                        (it, j) => (
                          <div key={j} style={_di}>
                            <span>
                              {it.date}
                              {/* Sans fournisseur, le libellé : la ligne ne
                                  montrait que sa date. */}
                              {sansTexteDuBulletin(it.fournisseur)
                                ? ' · ' + sansTexteDuBulletin(it.fournisseur)
                                : it.libelle && it.origine === 'frais'
                                  ? ' · ' + it.libelle
                                  : ''}
                              {it.ou ? ' · ' + it.ou : ''}
                              {it.libelle && it.origine !== 'frais' ? ' · ' + it.libelle : ''}
                              {/* La même facture saisie ailleurs : comptée une
                                  fois, ici, et le patron voit où est l'autre. */}
                              {it.aussi?.length ? (
                                <span style={{ color: C.grey }}>
                                  {' · ' + trf('aussi : {0}', it.aussi.join(', '))}
                                </span>
                              ) : null}
                              {it.origine === 'frais' &&
                              typeof it.id === 'number' &&
                              typeof setFrais === 'function' ? (
                                // Le jour du paiement se note ici à la main ; le
                                // relevé de banque le trouve tout seul.
                                <PayeLe
                                  payeLe={it.payeLe}
                                  payePar={it.paiement}
                                  source={
                                    { releve: tr('relevé bancaire'), main: tr('noté à la main') }[
                                      sourceDuPaiement(it, releves)
                                    ]
                                  }
                                  onChange={(v) =>
                                    setFrais((p) =>
                                      p.map((x) =>
                                        x.id === it.id
                                          ? {
                                              ...x,
                                              payeLe: v.payeLe,
                                              paiement: v.payeLe ? v.payePar : x.paiement,
                                            }
                                          : x,
                                      ),
                                    )
                                  }
                                />
                              ) : it.origine === 'comptable' ? (
                                // Les honoraires d'une période : payés ou pas,
                                // pointés d'un geste (le relevé les pointe aussi).
                                <button
                                  type="button"
                                  onClick={() => basculePaiement(it.periode)}
                                  style={{
                                    display: 'block',
                                    fontSize: 8.5,
                                    fontWeight: 700,
                                    color: it.paye ? C.green : C.amber,
                                    background: 'none',
                                    border: 'none',
                                    padding: 0,
                                    cursor: 'pointer',
                                  }}
                                >
                                  {it.libelle} ·{' '}
                                  {it.paye ? '✓ ' + tr('Payé') : '○ ' + tr('Pas encore payé')}
                                </button>
                              ) : it.payeLe ? (
                                <span
                                  style={{
                                    display: 'block',
                                    fontSize: 8.5,
                                    color: C.green,
                                    fontWeight: 700,
                                  }}
                                >
                                  ✓ {textePaye(it.payeLe, it.payePar || it.paiement)}
                                </span>
                              ) : null}
                            </span>
                            <span style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                              {it.pieceJointe ? (
                                <button
                                  type="button"
                                  aria-label={tr('Voir le justificatif')}
                                  onClick={() => ouvrePiece(it.pieceJointe)}
                                  style={{
                                    width: 32,
                                    height: 32,
                                    borderRadius: 6,
                                    border: '1px solid ' + C.border,
                                    background: '#fff',
                                    cursor: 'pointer',
                                    padding: 0,
                                  }}
                                >
                                  📄
                                </button>
                              ) : it.piece || it.photo ? (
                                // Le justificatif de la dépense (photo ou PDF), qui
                                // vit dans « piece » : le classeur ne lisait que
                                // « photo » et n'en montrait aucun.
                                <button
                                  type="button"
                                  aria-label={tr('Voir le justificatif')}
                                  onClick={() => ouvreDonnees(it.piece || it.photo, it.libelle)}
                                  style={{
                                    width: 32,
                                    height: 32,
                                    borderRadius: 6,
                                    border: '1px solid ' + C.border,
                                    background: '#fff',
                                    cursor: 'pointer',
                                    padding: 0,
                                    overflow: 'hidden',
                                  }}
                                >
                                  {String(it.piece || it.photo).startsWith('data:image') ? (
                                    <img
                                      src={it.piece || it.photo}
                                      alt=""
                                      style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                    />
                                  ) : (
                                    '📄'
                                  )}
                                </button>
                              ) : (
                                <span style={{ fontSize: 8, color: C.muted }}>—</span>
                              )}
                              <b>{DEVISE + ' ' + fmt(+it.montant || 0)}</b>
                              {it.origine === 'frais' && typeof setFrais === 'function' && (
                                // Un doublon se supprime ici, sans repasser par
                                // Dépenses : la TVA payée deux fois se voyait
                                // dans le classeur, sans moyen de l'enlever.
                                <button
                                  type="button"
                                  aria-label={tr('Supprimer la dépense')}
                                  onClick={() => {
                                    if (
                                      !window.confirm(
                                        tr('Supprimer cette dépense et son justificatif ?'),
                                      )
                                    )
                                      return;
                                    setFrais((p) => p.filter((y) => y.id !== it.id));
                                    if (it.chantierId && typeof setChantiers === 'function') {
                                      const catLib = (FRAIS_CAT[it.type] || {}).lib || it.type;
                                      setChantiers((p) =>
                                        p.map((c) => {
                                          if (String(c.id) !== String(it.chantierId)) return c;
                                          const i = factureDeLaDepense(c.factures, it, catLib);
                                          return i < 0
                                            ? c
                                            : {
                                                ...c,
                                                factures: c.factures.filter((_, k) => k !== i),
                                              };
                                        }),
                                      );
                                    }
                                  }}
                                  style={{
                                    background: 'none',
                                    border: 'none',
                                    color: C.muted,
                                    cursor: 'pointer',
                                    fontSize: 13,
                                    padding: '2px 4px',
                                  }}
                                >
                                  🗑
                                </button>
                              )}
                            </span>
                          </div>
                        ),
                        arr.reduce((t, x) => t + (+x.montant || 0), 0),
                        tickets || feuille ? (
                          <>
                            {tickets}
                            {feuille}
                          </>
                        ) : null,
                      )}
                    </div>
                  );
                })
              )}

              {!magC && (
                <ClasseurChantiers chantiers={chantiers} clients={clients} styleGroupe={_grp} />
              )}

              {magC && <ClasseurClients clients={clients} styleGroupe={_grp} />}

              {magC && (
                <>
                  <div style={_grp}>📋 Commandes & livraisons</div>
                  {card('📋', 'Bons de commande', commandes || [], C.purple, (o, i) =>
                    line((o.date || '') + ' · ' + (o.num || '#' + (i + 1)), '', C.purple, i),
                  )}
                  {card('🚚', 'Bons de livraison', livraisons || [], C.purple, (l, i) =>
                    line((l.date || '') + ' · ' + (l.num || '#' + (i + 1)), '', C.purple, i),
                  )}
                </>
              )}

              <CasiersPersonnel
                employes={employes}
                conges={conges}
                chantiers={chantiers}
                annee={anneeC}
                estLaMienne={maFiche.estLaMienne}
                styleGroupe={_grp}
              />

              {/* Un relevé par fichier importé (PDF ou camt.053), gardé tel
                  que transmis : il s'ouvre, et ceux qu'on coche partent à la
                  comptable. Les relevés importés avant que le fichier soit
                  gardé n'en ont pas : leurs mouvements restent dans Banque. */}
              {soc?.id != null && (
                <>
                  <div style={_grp}>🏦 Banque</div>
                  <RelevesBanque
                    annee={anneeC}
                    mouvements={releves}
                    factures={facturesToutes}
                    comptable={cpt}
                    chantiers={chantiers}
                    frais={fraisTous}
                    achats={achatsJoints}
                  />
                </>
              )}
            </div>
          );
        })()}

      {tab === 'marges' && (
        <div>
          {chantiers.map((ch) => {
            const { fac, st, mo, mat, ben } = chantierCosts(
              ch,
              employes,
              soc,
              facturesToutes,
              fraisTous,
              achatsDuChantier(ch, achatsJoints, devis, facturesToutes),
            );
            const marge = ch.facture > 0 ? Math.round((ben / ch.facture) * 100) : 0;
            return (
              <Card key={ch.id} style={{ marginBottom: 9 }}>
                <div style={{ padding: '12px 14px' }}>
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'flex-start',
                      marginBottom: 8,
                    }}
                  >
                    <div style={{ fontSize: 11, fontWeight: 700 }}>{ch.nom}</div>
                    <div
                      style={{ fontSize: 13, fontWeight: 900, color: ben >= 0 ? C.green : C.red }}
                    >
                      {marge}%
                    </div>
                  </div>
                  <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4,1fr)', gap: 5 }}>
                    {[
                      // Le prix du chantier (l'offre), sur lequel se lit la
                      // marge : « Facturé » annonçait 40'800.– sur un chantier
                      // dont seul l'acompte de 12'240.– était facturé.
                      ['Montant', ch.facture],
                      ['Matér.', fac + mat],
                      ['S-tr.', st],
                      ['M.O.', mo],
                    ].map(([l, v]) => (
                      <div
                        key={l}
                        style={{
                          background: C.navyXL,
                          borderRadius: 7,
                          padding: '6px 4px',
                          textAlign: 'center',
                        }}
                      >
                        <div style={{ fontSize: 6.5, color: C.muted }}>{l}</div>
                        <div style={{ fontSize: 8.5, fontWeight: 800 }}>{fmt(v)}</div>
                      </div>
                    ))}
                  </div>
                  {ben < 0 && (
                    <div
                      style={{
                        marginTop: 8,
                        background: C.redL,
                        borderRadius: 8,
                        padding: '7px 10px',
                        fontSize: 9,
                        color: C.red,
                        fontWeight: 700,
                      }}
                    >
                      ⚠ Chantier déficitaire
                    </div>
                  )}
                </div>
              </Card>
            );
          })}
        </div>
      )}
    </Shell>
  );
}
